$(function(){
  enableSliderButton();
  fixedPdpThumbnailPos();
  initDate();
    autoAddGwp();
    autoTierGwp();
    gwpColMinCartQty();
    bindGwpSampleDropdownEvents();
    fixedPdpThumbnailPos();
    updateShippingProgress();
    updateGwpSamppleProgress();
    gwpSampleDropdown();
    bindGwpSampleCheckoutGuard();
    updateGwpSampleCheckoutState();
    autoSelectGwpSamples();
    maintainScrollPosition();
    openLinkNewTab();
    updateComplementaryArrow();
    updateMilestonePosition();
    toggleComplementaryArrow();
    buyXGetYGwp();
    removeInvalidFreeItems();
    initCartOnlyUpsellSlider();
    window.addEventListener('resize', scheduleEqualizeAllCartUpsellTitles);
    klaviyoFormHeadingUpdate();
    // Use fast check on page load (works for both cart page and drawer)
    if (typeof checkGiftWrapInCartFast === 'function') {
      checkGiftWrapInCartFast();
    } else if (typeof checkGiftWrapInCart === 'function') {
      checkGiftWrapInCart();
    }
    jscInitGridVariantPillScroll();

    window.addEventListener('resize', scheduleHeaderSearchPanelSync);
    /* Page scroll only — capture:true also fired on #Search-menu-drawer-header scroll and re-synced panel position (jump at scroll top). */
    window.addEventListener('scroll', scheduleHeaderSearchPanelSync, { passive: true });

    var searchDetailsEl = document.getElementById('Search-drawer-header');
    if (searchDetailsEl) {
      searchDetailsEl.addEventListener('toggle', function () {
        if (!searchDetailsEl.hasAttribute('open')) {
          clearHeaderSearchPanelVars();
          $('#Search-menu-drawer-header').css({
            opacity: '',
            visibility: '',
            transform: ''
          });
        }
      });
    }
});

// start: gwp sample checkout guard (require exact sample count)
getGwpSampleCountLeft = () => {
  // Prefer the hidden marker rendered in cart page/cart drawer.
  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length > 0) {
    var raw = $marker.attr('data-countleft');
    var parsed = parseInt(raw, 10);
    if (!Number.isNaN(parsed)) return parsed;
  }

  // Fallback to the visible text inside the sample section (if present).
  var $count = $('.jsc-gwpsample-section .jsc-gwpsample-count-left .count:first');
  if ($count.length > 0) {
    var parsedText = parseInt($count.text().trim(), 10);
    if (!Number.isNaN(parsedText)) return parsedText;
  }

  return null;
}

parseBooleanAttr = (raw) => {
  if (raw == null) return false;
  var val = raw.toString().toLowerCase().trim();
  return (val === 'true' || val === '1' || val === 'yes');
}

// If customer manually adjusts samples, pause auto-select until full page refresh.
setGwpSampleManualOverride = () => {
  window.__jscGwpSampleManualOverrideActive = true;
}

isGwpSampleManualOverrideActive = () => {
  return window.__jscGwpSampleManualOverrideActive === true;
}

isGwpSampleSelectionRequired = () => {
  // The marker is only rendered when the GWP sample feature is enabled.
  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length == 0) return false;

  var raw = ($marker.attr('data-required') || '');
  if (parseBooleanAttr(raw)) return true;

  // Unknown/false: treat as not required to avoid blocking checkout unexpectedly.
  return false;
}

isGwpSampleAutoSelectEnabled = () => {
  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length == 0) return false;
  return parseBooleanAttr($marker.attr('data-autoselect'));
}

setGwpSampleErrorVisible = (isVisible) => {
  var $error = $('.jsc-gwpsample-section .jsc-gwpsample-error-text:first');
  if ($error.length == 0) return;

  if (isVisible) {
    $error.removeClass('d-none');
  } else {
    $error.addClass('d-none');
  }
}

scrollToGwpSampleSection = () => {
  var $section = $('.jsc-gwpsample-section:first');
  if ($section.length == 0) return;

  var el = $section.get(0);

  // Single smooth scroll to avoid "jumping" (no follow-up scrollBy nudge).
  // Try to account for sticky header height if present.
  var headerOffset = 100;
  try {
    var $stickyHeader = $('sticky-header:visible:first');
    if ($stickyHeader.length > 0) {
      headerOffset = Math.max(headerOffset, $stickyHeader.outerHeight() || 0);
    } else {
      var $header = $('header:visible:first');
      if ($header.length > 0) headerOffset = Math.max(headerOffset, $header.outerHeight() || 0);
    }

    var rect = el.getBoundingClientRect();
    var absoluteTop = rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
    var targetTop = Math.max(0, absoluteTop - headerOffset);

    // If we're already basically there, don't scroll again.
    if (Math.abs((window.pageYOffset || 0) - targetTop) < 8) return;

    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: targetTop, left: 0, behavior: 'smooth' });
    } else {
      $('html, body').animate({ scrollTop: targetTop }, 350);
    }
  } catch (e) {
    // Fallback for older browsers
    $('html, body').animate({ scrollTop: $section.offset().top - headerOffset }, 350);
  }
}

disableCheckoutBriefly = (triggerEl, ms) => {
  var duration = ms || 1200;

  // Disable the clicked element, and also the main checkout button(s) to prevent double submits.
  var $targets = $('.jsc_cart__checkout');
  if (triggerEl) $targets = $targets.add($(triggerEl));

  $targets.each(function() {
    var $el = $(this);
    if ($el.is('button, input, select, textarea')) {
      $el.attr('disabled', true).addClass('is-disabled');
    } else {
      $el.attr('aria-disabled', 'true').addClass('is-disabled');
      $el.css('pointer-events', 'none');
    }
  });

  setTimeout(() => {
    $targets.each(function() {
      var $el = $(this);
      if ($el.is('button, input, select, textarea')) {
        $el.removeAttr('disabled').removeClass('is-disabled');
      } else {
        $el.removeAttr('aria-disabled').removeClass('is-disabled');
        $el.css('pointer-events', '');
      }
    });
  }, duration);
}

updateGwpSampleCheckoutState = () => {
  // Only applies when the sample section exists on the page.
  if ($('.jsc-gwpsample-section').length == 0) return;

  // If selection is not required, never show the blocking error.
  if (!isGwpSampleSelectionRequired()) {
    setGwpSampleErrorVisible(false);
    return;
  }

  var countLeft = getGwpSampleCountLeft();
  if (countLeft == null) return;

  // Hide the error once the user has met (or exceeded) the sample requirement.
  if (countLeft <= 0) {
    setGwpSampleErrorVisible(false);
  }
}

bindGwpSampleCheckoutGuard = () => {
  if (window.__jscGwpSampleCheckoutGuardBound) return;
  window.__jscGwpSampleCheckoutGuardBound = true;

  var blockIfSamplesMissing = (e, triggerEl) => {
    // Only block if the section is enabled/present.
    if ($('.jsc-gwpsample-section').length == 0) return true;

    // Only enforce when the theme setting requires selecting samples.
    if (!isGwpSampleSelectionRequired()) {
      setGwpSampleErrorVisible(false);
      return true;
    }

    var countLeft = getGwpSampleCountLeft();
    if (countLeft == null) return true;

    if (countLeft > 0) {
      if (e && e.preventDefault) e.preventDefault();
      if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

      disableCheckoutBriefly(triggerEl, 1200);
      setGwpSampleErrorVisible(true);
      scrollToGwpSampleSection();
      return false;
    }

    // Requirement met; ensure error is hidden.
    setGwpSampleErrorVisible(false);
    return true;
  };

  // Handle clicks on checkout buttons/links.
  $(document).on('click', 'button[name="checkout"], input[name="checkout"], .jsc_cart__checkout, a[href="/checkout"]', function(e) {
    // Save cart note before checkout (form submit handler will also save it, but this ensures it's saved even if form is prevented)
    var noteInput = document.querySelector('#cart-note, textarea[name="note"]');
    if (noteInput) {
      var noteValue = noteInput.value || '';
      // Save note asynchronously (form submit handler provides backup)
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ note: noteValue })
      });
    }
    return blockIfSamplesMissing(e, this);
  });

  // Handle "Enter to submit" on cart forms (cart page + drawer).
  $(document).on('submit', 'form[action*="/cart"]', function(e) {
    var submitter = e.originalEvent && e.originalEvent.submitter ? e.originalEvent.submitter : null;
    if (submitter && $(submitter).is('[name="checkout"], .jsc_cart__checkout')) {
      return blockIfSamplesMissing(e, submitter);
    }
    return true;
  });

  // Keep state in sync after cart updates (AJAX cart drawer/cart page rerenders).
  $(document).on('cart.requestComplete cart:updated', function() {
    setTimeout(() => {
      gwpSampleDropdown();
      updateGwpSampleCheckoutState();
      autoSelectGwpSamples();
    }, 200);
  });
}
// end: gwp sample checkout guard

// start: gwp sample auto select
cartAddItems = (items) => {
  if (!items || items.length == 0) return;

  showCartSpinner();

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => response.json())
  .then(() => {
    if (window.location.pathname === '/cart') {
      location.reload();
      return;
    }

    removeCartSpinner();
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Trigger drawer re-render; vid is not important here.
      updateCartDrawer(items[0].id, cartDrawer);
    }
  })
  .catch((error) => {
    console.error('Error auto selecting GWP samples:', error);
    removeCartSpinner();
  });
}

getGwpSampleAutoSelectCandidates = (existingSampleVariantIds) => {
  var candidates = [];
  var addCandidate = (vid) => {
    if (Number.isNaN(vid)) return;
    if (existingSampleVariantIds.has(vid)) return;
    if (candidates.indexOf(vid) !== -1) return;
    candidates.push(vid);
  };

  // Dropdown layout: collection order via list rows.
  $('.jsc-gwpsample-section .jsc-cart-sample-dropdown-row[data-vid]').each(function() {
    var $row = $(this);
    if ($row.hasClass('jsc-cart-sample-dropdown-row--oos')) return;
    addCandidate(parseInt($row.attr('data-vid'), 10));
  });
  if (candidates.length > 0) return candidates;

  // Default (slider) layout: ADD SAMPLE buttons.
  $('.jsc-gwpsample-section .__jsc-gwp-sample-atc[data-vid]').each(function() {
    addCandidate(parseInt($(this).attr('data-vid'), 10));
  });

  return candidates;
}

autoSelectGwpSamples = () => {
  // Only applies when the sample section exists on the page.
  if ($('.jsc-gwpsample-section').length == 0) return;
  if (!isGwpSampleAutoSelectEnabled()) return;
  // Don't auto-select while customer is manually adjusting sample choices.
  if (isGwpSampleManualOverrideActive()) return;
  if (window.__jscAutoSelectGwpSamplesRunning) return;

  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length == 0) return;

  var requiredCount = parseInt($marker.attr('data-count'), 10);
  var countLeft = getGwpSampleCountLeft();
  if (Number.isNaN(requiredCount) || requiredCount <= 0) return;
  if (countLeft == null || countLeft <= 0) return;

  window.__jscAutoSelectGwpSamplesRunning = true;

  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
    .then(r => r.json())
    .then(cart => {
      // Collect already-selected sample variant ids in cart to avoid duplicates.
      var existingSampleVariantIds = new Set(
        (cart.items || [])
          .filter(item => item.properties && item.properties['_GWP Sample'])
          .map(item => parseInt(item.id, 10))
          .filter(id => !Number.isNaN(id))
      );

      var candidates = getGwpSampleAutoSelectCandidates(existingSampleVariantIds);

      var need = Math.min(countLeft, candidates.length);
      if (need <= 0) return;

      var items = [];
      for (var i = 0; i < need; i++) {
        items.push({
          id: candidates[i],
          quantity: 1,
          properties: { '_GWP Sample': 'Free Gift' }
        });
      }

      cartAddItems(items);
    })
    .catch(error => {
      console.error('Error checking cart for auto selecting samples:', error);
    })
    .finally(() => {
      // Allow another attempt later if needed.
      window.__jscAutoSelectGwpSamplesRunning = false;
    });
}
// end: gwp sample auto select

// Pause auto-select whenever customer interacts with sample selection UI.
$(document).on(
  'click',
  '.jsc-gwpsample-section .__jsc-gwp-sample-atc, .jsc-gwpsample-section .quantity__button, .jsc-cart-sample-dropdown-row .quantity__button, .jsc-cart-gwp-lineitems .quantity__button, .jsc-cart-gwp-lineitems cart-remove-button, .__remove-allgwp, .jsc-cart-sample-dropdown-clear, .jsc-cart-sample-dropdown__tab-chip-remove',
  function() {
    setGwpSampleManualOverride();
  }
);

// start: open external link in new tab
openLinkNewTab = () => {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}
// end: open external link in new tab

clickParentNav = (nav) => {
 var nav = $(nav);
 nav.parent('.js-btn').click();
}

fixedPdpThumbnailPos = () => {
    var $swiper = $('.product__media .swiper-thumbs-container .swiper-wrapper');
    var $swiperSlide = $($swiper).find('.swiper-slide');

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                $swiper.removeAttr('style');
                console.log('Class changed:', $swiperSlide.length);
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Attach the observer to each target node
    if($swiperSlide.length <= 5) {
        $swiperSlide.each(function(index, targetNode) {
            // Inside the each() callback, attach the observer to the current targetNode
            observer.observe(targetNode, { attributes: true, attributeFilter: ['class'] });
        });
    }
}
function onloadQuantity(itemId) {
    var errorMessage = document.querySelector('.cart-drawer__form #CartItem-' + itemId + ' .jsc-error-message');
    var errorMessageCartPage = document.querySelector('.cart__main #CartItem-' + itemId + ' .jsc-error-message');
  
    setTimeout(() => {
      var input = document.querySelector('.cart-drawer__form #CartItem-' + itemId + ' .quantity__input');
      if (input && errorMessage) {
        var currentValue = parseInt(input.value);
        var maxValue = parseInt(input.getAttribute('max'));

        if (currentValue >= maxValue) {
          errorMessage.style.display = 'block';
        } else {
          errorMessage.style.display = 'none';
        }
      }

      var inputCartPage = document.querySelector('.cart__main #CartItem-' + itemId + ' .quantity__input');
      if (inputCartPage && errorMessageCartPage) {
        var currentValueCartPage = parseInt(inputCartPage.value);
        var maxValueCartPage = parseInt(inputCartPage.getAttribute('max'));

        if (currentValueCartPage >= maxValueCartPage) {
          errorMessageCartPage.style.display = 'block';
        } else {
          errorMessageCartPage.style.display = 'none';
        }
      }
    }, 1500);
  }

  initTrustBadgeSlider = () => {
    var slider = $('.section-trust-indicators__swiper .section-trust-indicators__swiper-wrapper');
    var lastSlideIndex = $(slider).find('.swiper-slide').length - 1;
    var sliderNextBtn = $(slider).siblings('.swiper-buttons').find('.swiper-button--next');
    var sliderPrevBtn = $(slider).siblings('.swiper-buttons').find('.swiper-button--prev');

    if($(window).width() < 481) {
      if (typeof $.fn.flickity !== 'function') return;

      $(slider).flickity({
        cellAlign: 'left',
        wrapAround: false,
        contain: true,
        pageDots: false,
        prevNextButtons: false
      });

      sliderNextBtn.removeClass('swiper-button-lock');
      sliderNextBtn.removeClass('swiper-button-disabled');
      sliderNextBtn.removeAttr('disabled');
      sliderPrevBtn.removeClass('swiper-button-disabled');
      sliderPrevBtn.removeAttr('disabled');

      slider.on( 'change.flickity', function(event, index) {
        sliderNextBtn.removeClass('swiper-button-disabled');
        sliderNextBtn.removeAttr('disabled');
        sliderPrevBtn.removeClass('swiper-button-disabled');
        sliderPrevBtn.removeAttr('disabled');

        if(index == 0) {
          sliderPrevBtn.addClass('swiper-button-lock');
          sliderNextBtn.removeClass('swiper-button-lock');
        }
        else if(index == lastSlideIndex) {
          sliderPrevBtn.removeClass('swiper-button-lock');
          sliderNextBtn.addClass('swiper-button-lock');
        }
        else {
          sliderPrevBtn.removeClass('swiper-button-lock');
          sliderNextBtn.removeClass('swiper-button-lock');
        }
      });

      if (!$(sliderPrevBtn).data('click-attached')) {
        $(sliderPrevBtn).on('click', function() {
            console.log('prev click');
            slider.flickity('previous');
        });
    
        $(sliderPrevBtn).data('click-attached', true);
      }

      if (!$(sliderNextBtn).data('click-attached')) {
        $(sliderNextBtn).on('click', function() {
            console.log('next click');
            slider.flickity('next');
        });
    
        $(sliderNextBtn).data('click-attached', true);
      }
    }
  }

  editAccountEdit = (e) =>{
    var _this = $(e);

    $('.jsc-static-info').hide();
    $('.jsc-klaviyo-form').show();
  }

  cancelUpdate = (e) =>{
    var _this = $(e);
    
    $('.jsc-klaviyo-form').hide();
    $('.jsc-static-info').show();
  }
  
  initDate = () =>{
    var startDate = new Date(1900, 1 - 1, 1);
    var currentDate = new Date();
    var endDate = new Date(new Date().getFullYear() - 12, currentDate.getMonth(), currentDate.getDate());
    
    if ($('#jsc-date-of-birth').length) {
      $('#jsc-date-of-birth').datepicker({
        dateFormat: 'dd/mm/yy',
        minDate: startDate,
        maxDate: endDate
      });
    }
  }

  updateProfile = (e) =>{
    var _this = $(e);
    var loader = $('.jsc-loader-overlay');

    loader.show();

    var firstName = $('#jsc-first-name').val();
    var lastName = $('#jsc-last-name').val();
    var dateOfBirth = $('#jsc-date-of-birth').val();
    var gender = $('#jsc-gender').val();
    var email = $('#jsc-email').val();
    var country = $('#jsc-country').val();

    var settings = {
      "url": "https://a.klaviyo.com/client/profiles/?company_id=wHzJ88",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "content-type": "application/json",
        "revision": "2024-05-15"
      },
      "data": JSON.stringify({
        "data": {
          "type": "profile",
          "attributes": {
            "email": email,
            "first_name": firstName,
            "last_name": lastName,
            "properties": {
              "birthday": dateOfBirth,
              "Gender": gender,
              "country": country
            }
          }
        }
      }),
    };
    
    $.ajax(settings).done(function (response) {
      // console.log('Sumbit', response);
      setTimeout(() => {
        $('.ad-birthday').html(dateOfBirth);
        $('.ad-gender').html(gender);
        $('.ad-country').html(country);
        loader.hide();
        $('.jsc-static-info').show();
        $('.jsc-klaviyo-form').hide();
      }, 1200);
    });
  }
  // start: update cart shipping bar
  updateShippingProgress = () => {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      var totalPrice = data.total_price;
      var threshold = parseInt($('.jsc-shipping-progress-bar.progress-bar .progress-bar__progress').attr('data-threshold'));
      var thresholdPercentage = totalPrice / threshold * 100;
      var progressBarWrapper = $('.jsc-shipping-progress-bar.progress-bar');
      var progressBarProgress = $('.jsc-shipping-progress-bar.progress-bar .progress-bar__progress-inner');
      var progressBarText = $('.jsc-shipping-progress-bar.progress-bar .progress-bar__text');

      if(data.item_count > 0 && threshold > 0) {
        progressBarWrapper.addClass('active');
        if(thresholdPercentage < 0) {
          thresholdPercentage = 0;
        }
        else if(thresholdPercentage > 100) {
          thresholdPercentage = 100;
        }

        progressBarWrapper.attr('data-progress', 'calc(' + thresholdPercentage + '% + 2px)');
        progressBarProgress.css('width', 'calc(' + thresholdPercentage + '% + 2px)');

        if(thresholdPercentage < 100) {
          var remainingAmount = (threshold - totalPrice) / 100;
          progressBarText.text('Only $' + remainingAmount.toFixed(2) + ' away from free shipping');
        }
        else {
          progressBarText.text("Congrats! You're qualified for free shipping!");
        }
      }
      else {
        progressBarWrapper.removeClass('active');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  // end: update cart shipping bar

  // start: cart gwp sample ATC
  gwpSampleAtc = (e) => {
    // Customer is manually choosing a sample; pause auto-select.
    setGwpSampleManualOverride();
    var $gwp_prop = {};
    var $vid = parseInt($(e).attr('data-vid'));

    $gwp_prop['_GWP Sample'] = 'Free Gift';

    window.__jscGwpSampleDropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');
    showCartSpinner();
    cartJSAdd($vid, 1, $gwp_prop);
  }

  minusQtySample = (key) => {
    // Customer is manually changing samples; pause auto-select.
    setGwpSampleManualOverride();
    window.__jscGwpSampleDropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');
    $('.jsc-cart-gwp-lineitems .__minus_'+key).click();
  }

  addQtySample = (key) => {
    // Customer is manually changing samples; pause auto-select.
    setGwpSampleManualOverride();
    window.__jscGwpSampleDropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');
    $('.jsc-cart-gwp-lineitems .__plus_'+key).click();
  }

  gwpSampleRemoveByVid = (vid) => {
    setGwpSampleManualOverride();

    fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var item = (cart.items || []).find(function(lineItem) {
          return parseInt(lineItem.id, 10) === parseInt(vid, 10) &&
            lineItem.properties &&
            lineItem.properties['_GWP Sample'];
        });

        if (!item) return;
        cartJSUpdate(item.key, 0, {}, false);
      })
      .catch(function(error) {
        console.error('Error removing GWP sample:', error);
      });
  }

  removeAllGwpSample = (keylist) => {
    // Customer is clearing samples; pause auto-select so they can re-pick.
    setGwpSampleManualOverride();
    window.__jscGwpSampleDropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');
    showCartSpinner();

    var keysplit = keylist.split(",");
    var jsonObj = {};
    for (i=0;i<keysplit.length;i++){
        jsonObj[keysplit[i]] = 0;
    }
    console.log(jsonObj);
    CartJS.updateItemQuantitiesById(jsonObj);

    $(document).one('cart.requestComplete', function() {
      if (window.location.pathname === '/cart') {
        refreshCartContentsAfterSampleChange().finally(function() {
          removeCartSpinner();
        });
        return;
      }

      location.reload();
    });

  }

  // end: cart gwp sample ATC

// start: update cart gwp sample bar
// updateGwpSamppleProgress = () => {

  
//   $.when($.getJSON('/cart.js', function(cart) {
//     cart_originaltotal = cart.original_total_price;
//     cart_totalcount = cart.item_count;
//   })).then(function(cart){
//       // console.log(cart,cart_originaltotal,'cart_originaltotal');
//       var currTierCount = parseInt($('.__gwpsample-currenttier_countleft:last').attr('data-count'));
//       var currTierCountLeft = parseInt($('.__gwpsample-currenttier_countleft:last').attr('data-countleft'));
//       // console.log(currTierCountLeft,'currTierCountLeft',$('.__gwpsample-currenttier_countleft:last'),'currTierCount',currTierCount);
    
//       if ((currTierCountLeft < 0) || (currTierCount < 1)) {
//         var gwpKeylist = $('.__remove-allgwp').attr('data-gwpKeylist');
//         if (gwpKeylist){
//           removeAllGwpSample(gwpKeylist);
//         }
//       }

//       var gwpsample_enabled = $('.jsc-gwpsample-section');
//       if (gwpsample_enabled.length > 0){
//         var totalPrice = cart_originaltotal;
//         var threshold = parseInt($('.jsc-gwpsample-section .progress-bar .progress-bar__progress').attr('data-threshold'));
//         var thresholdPercentage = totalPrice / threshold * 100;
//         var progressBarWrapper = $('.jsc-gwpsample-section .progress-bar');
//         var progressBarProgress = $('.jsc-gwpsample-section .progress-bar .progress-bar__progress-inner');
//         var progressBarText = $('.jsc-gwpsample-section .progress-bar .progress-bar__text');
     

//         if(cart_totalcount > 0 && threshold > 0) {
//           progressBarWrapper.addClass('active');
//           if(thresholdPercentage < 0) {
//             thresholdPercentage = 0;
//           }
//           else if(thresholdPercentage > 100) {
//             thresholdPercentage = 100;
//           }

//           progressBarWrapper.attr('data-progress', 'calc(' + thresholdPercentage + '% + 2px)');
//           progressBarProgress.css('width', 'calc(' + thresholdPercentage + '% + 2px)');

      //     if(thresholdPercentage < 100) {
      //       var remainingAmount = (threshold - totalPrice) / 100;
      //       progressBarText.html('Only $' + remainingAmount.toFixed(2) + ' away from getting a <b>COMPLIMENTARY SAMPLE!</b>');
      //     }
      //     else {
      //       progressBarText.html("Congrats! You're qualified for <b>" + currTierCount + " COMPLIMENTARY SAMPLE(S)!</b> - redeem now");
      //     }
      //   }
      //   else {
      //     progressBarWrapper.removeClass('active');
      //   }
      // }

//   });

// }
// end: update cart gwp sample bar


  // start: Cart Event
  parseSectionInnerHTML = (html, selector) => {
    var el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return el ? el.innerHTML : '';
  }

  getCartPageSectionsToRender = () => {
    var mainCartItems = document.getElementById('main-cart-items');
    if (!mainCartItems || !mainCartItems.dataset.id) return null;

    var sectionId = mainCartItems.dataset.id;

    return [
      {
        id: '#shopify-section-' + sectionId,
        section: sectionId,
        selector: '#shopify-section-' + sectionId + ' cart-items'
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  restoreGwpSampleDropdownOpenState = (wasOpen) => {
    if (!wasOpen) return;

    var $dropdown = $('.jsc-cart-sample-dropdown:first');
    if ($dropdown.length === 0) return;

    $dropdown.addClass('is-open');
    $dropdown.find('.jsc-cart-sample-dropdown__tab:first').attr('aria-expanded', 'true');
    $dropdown.find('.jsc-cart-sample-dropdown__panel:first').removeAttr('hidden');
  }

  runCartContentRefreshCallbacks = () => {
    if (typeof updateGwpSamppleProgress === 'function') updateGwpSamppleProgress();
    if (typeof updateShippingProgress === 'function') updateShippingProgress();
    if (typeof autoAddGwp === 'function') autoAddGwp();
    if (typeof autoTierGwp === 'function') autoTierGwp();
    if (typeof gwpColMinCartQty === 'function') gwpColMinCartQty();
    if (typeof buyXGetYGwp === 'function') buyXGetYGwp();
    if (typeof removeInvalidFreeItems === 'function') removeInvalidFreeItems();
    if (typeof updateMilestonePosition === 'function') updateMilestonePosition();
    if (typeof gwpSampleDropdown === 'function') gwpSampleDropdown();
    if (typeof updateGwpSampleCheckoutState === 'function') updateGwpSampleCheckoutState();
    if (typeof initCartOnlyUpsellSlider === 'function') {
      setTimeout(function () { initCartOnlyUpsellSlider(); }, 0);
    }

    setTimeout(function() {
      if (typeof checkGiftWrapInCart === 'function') {
        checkGiftWrapInCart();
      } else if (typeof checkGiftWrapInCartFast === 'function') {
        checkGiftWrapInCartFast();
      }
    }, 500);
  }

  refreshCartContentsAfterSampleChange = (hintVid) => {
    if (window.location.pathname === '/cart') {
      var sections = getCartPageSectionsToRender();
      if (!sections) return Promise.resolve();

      var dropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');
      var sectionParam = sections.map(function(section) {
        return section.section;
      }).join(',');

      return fetch(
        window.Shopify.routes.root +
          '?sections=' +
          sectionParam +
          '&sections_url=' +
          encodeURIComponent(window.location.pathname)
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(state) {
          sections.forEach(function(section) {
            var html = state[section.section];
            if (!html) return;

            var elementToReplace =
              section.id === '#cart-counter'
                ? document.querySelector(section.id)
                : document.querySelector(section.selector);

            if (!elementToReplace) return;

            elementToReplace.innerHTML = parseSectionInnerHTML(html, section.selector);
          });

          runCartContentRefreshCallbacks();
          restoreGwpSampleDropdownOpenState(dropdownWasOpen);

          try {
            $(document).trigger('cart.requestComplete');
            $(document).trigger('cart:updated');
          } catch (e) {}
        })
        .catch(function(error) {
          console.error('Error refreshing cart contents:', error);
          removeCartSpinner();
          location.reload();
        });
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof updateCartDrawer === 'function' && hintVid) {
      var dropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');
      updateCartDrawer(hintVid, cartDrawer, { preserveDropdownOpen: dropdownWasOpen });
    }

    return Promise.resolve();
  }

  cartJSAdd = (vid, qty, obj) => {
    CartJS.addItem(vid, qty, obj, {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        if (window.location.pathname === '/cart') {
          refreshCartContentsAfterSampleChange(vid).finally(function() {
            removeCartSpinner();
          });
          return;
        }

        var cartDrawer = document.querySelector('cart-drawer');
        var dropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');

        if (cartDrawer) {
          updateCartDrawer(vid, cartDrawer, { preserveDropdownOpen: dropdownWasOpen })
            .finally(function() {
              removeCartSpinner();
              if (typeof checkGiftWrapInCartFast === 'function') {
                checkGiftWrapInCartFast();
              }
            });
          return;
        }

        removeCartSpinner();
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        removeCartSpinner();
        console.log('There was a problem adding to the cart!');
      
      }
    });
  }

  cartJSUpdate = (vid, qty, obj, disabledCheckoutBtn) => {
    // Cart js add item, success callback, error callback  
    CartJS.updateItemById(vid, qty, obj,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
          },
          success: function(cart) {
            console.log(disabledCheckoutBtn,'disabledCheckoutBtn');
            if (disabledCheckoutBtn){
              console.log('dont enabel checkout yet');
              // don't enable the checkout button yet
            }else{
              removeCartSpinner();
            }

              if (window.location.pathname === '/cart') {
                if (disabledCheckoutBtn){
                  // don't enable the checkout button yet
                  console.log('dont enabel checkout yet');
                }else{
                  refreshCartContentsAfterSampleChange(vid).finally(function() {
                    removeCartSpinner();
                    $('.jsc-loader-overlay').hide();
                  });
                }
              }
              else {
                var cartDrawer = document.querySelector('cart-drawer');
                var dropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');
                updateCartDrawer(vid, cartDrawer, { preserveDropdownOpen: dropdownWasOpen });
                // Fast check for cart drawer
                if (typeof checkGiftWrapInCartFast === 'function') {
                  checkGiftWrapInCartFast();
                }
                $('.jsc-loader-overlay').hide();
              }
            
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        $('.jsc-loader-overlay').hide();
      }
    });
  }

  updateCartDrawer = (vid, cartDrawer, options) => {
    options = options || {};
    const formData = new FormData();
    formData.append('id', 19534838534);
    formData.append('quantity', 0);
    formData.append(
      'sections',
      cartDrawer
        .getSectionsToRender()
        ?.map(section => section.section)
    );
    formData.append('sections_url', window.location.pathname);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    return fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then(addToCartData => {
      cartDrawer.renderContents(addToCartData, true);
      restoreGwpSampleDropdownOpenState(options.preserveDropdownOpen);
      // Fast check for cart drawer (renderContents already calls it, but this is a backup)
      if (typeof checkGiftWrapInCartFast === 'function') {
        setTimeout(() => {
          checkGiftWrapInCartFast();
        }, 200);
      }
    })
    .catch(error => {
      console.error('Error adding to cart or updating drawer:', error);
    });
  }
  // end: Cart Event

  // start: cart recommendation upsell
  cartUpsellAtc = (e) => {
    var vid = parseInt($(e).attr('data-vid'));
    cartJSAdd(vid, 1, {});
  }

  cartOnlyUpsellAtc = (e) => {
    var vid = parseInt($(e).attr('data-vid'));
    cartJSAdd(vid, 1, { '_Special_cart_discount': 'true' });
  }

  cartOnlyUpsellQty = (key, newQty) => {
    showCartSpinner();
    if (newQty <= 0) {
      cartJSUpdate(key, 0, {});
    } else {
      cartJSUpdate(key, newQty, { '_Special_cart_discount': 'true' });
    }
  }

  getCartRecommendationRoots = () => {
    return document.querySelectorAll('.jsc-cart-only-cart-recommendations, cart-recommendations.cart-recommendations');
  }

  equalizeCartUpsellTitles = (el) => {
    var titles = el.querySelectorAll('.cart-recommendations__item-title');
    if (!titles.length) return;
    var max = 0;
    titles.forEach(function (t) {
      t.style.minHeight = '';
      t.style.height = 'auto';
    });
    titles.forEach(function (t) { max = Math.max(max, t.offsetHeight); });
    titles.forEach(function (t) { t.style.minHeight = max + 'px'; });
  }

  scheduleCartUpsellTitleEqualize = (el) => {
    requestAnimationFrame(function () {
      equalizeCartUpsellTitles(el);
    });
  }

  var cartUpsellTitleResizeTimer;
  equalizeAllCartUpsellTitles = () => {
    getCartRecommendationRoots().forEach(function (el) {
      equalizeCartUpsellTitles(el);
    });
  }

  scheduleEqualizeAllCartUpsellTitles = () => {
    clearTimeout(cartUpsellTitleResizeTimer);
    cartUpsellTitleResizeTimer = setTimeout(equalizeAllCartUpsellTitles, 150);
  }

  initCartOnlyUpsellSlider = () => {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.jsc-cart-only-cart-recommendations').forEach(function (el) {
      var swiperEl = el.querySelector('.swiper');
      if (!swiperEl) return;
      var swipeOptions = {
        allowTouchMove: true,
        simulateTouch: true,
        threshold: 3,
        resistanceRatio: 0.72,
        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        noSwipingSelector: '.jsc-grid-variant-selector-viewport, .swiper-no-swiping',
      };
      if (swiperEl.swiper) {
        swiperEl.swiper.allowTouchMove = true;
        Object.assign(swiperEl.swiper.params, swipeOptions);
        swiperEl.swiper.update();
        scheduleCartUpsellTitleEqualize(el);
        if (typeof jscInitGridVariantPillScroll === 'function') {
          jscInitGridVariantPillScroll(el);
        }
        if (typeof jscInitGridVariantDragScroll === 'function') {
          jscInitGridVariantDragScroll(el);
        }
        return;
      }
      new Swiper(swiperEl, {
        ...swipeOptions,
        slidesPerView: 'auto',
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: el.querySelector('.swiper-button--next'),
          prevEl: el.querySelector('.swiper-button--prev'),
        },
      });
      scheduleCartUpsellTitleEqualize(el);
      if (typeof jscInitGridVariantPillScroll === 'function') {
        jscInitGridVariantPillScroll(el);
      }
      if (typeof jscInitGridVariantDragScroll === 'function') {
        jscInitGridVariantDragScroll(el);
      }
    });
  }

  showUpsellVariants = (e) => {
    var variantWrapper = $(e).siblings('.cart-recommendations__item-variant-wrapper');
    variantWrapper.addClass('active');
    $(e).hide();
  }
  // end: cart recommendation upsell

  // start: store locator prevent scroll
  maintainScrollPosition = () => {
    var $storeMap = $('#storemapper');
    if($storeMap.length > 0) {
      const intervalId = setInterval(() => {
        var $viewMapBtn = $('#storemapper-list .storemapper_view');
        var $mapSearchBtn = $('#storemapper-go');

        if($viewMapBtn.length > 0) {
          clearInterval(intervalId);

          $viewMapBtn.each(function() {
            $(this).on('click', function() {
              var xpos = window.scrollX;
              var ypos = window.scrollY;

              setTimeout(() => {
                window.scrollTo(xpos, ypos);
              }, 100);
            });
          });

          $mapSearchBtn.on('click', function() {
            console.log('search click')
            var xpos = window.scrollX;
            var ypos = window.scrollY;

            setTimeout(() => {
              window.scrollTo(xpos, ypos);
            }, 100);
          });
        }
      }, 100);
    }
  }
  // end: store locator prevent scroll

  // start: reorder
  reorderAtc = (e) => {
    var vid = parseInt($(e).parent().parent().attr('data-vid'));
    console.log('atc', vid);
    cartJSAdd(vid, 1, {});
  }
  // end: reorder

// start: complementary slider arrow pos
updateComplementaryArrow = () => {
  var $complementaryContainer = $('.section-complete-the-set');
  var $complementarySec = $('complementary-products');
  if($complementarySec.length > 0) {
    var intervalId = setInterval(() => {
      var $productCards = $($complementarySec).find('.card-product-slider__slide');
      var $prevBtn = $($complementaryContainer).find('.swiper-button--prev');
      var $nextBtn = $($complementaryContainer).find('.swiper-button--next');
      var $slider = $($complementarySec).find('.card-product-slider__wrapper');

      if($productCards.length > 0) {
        var cardWidth = $productCards.first().width();
        var totalProducts = $productCards.length;
        var containerWidth = $complementarySec.width();
        var maxCard = 0;

        if($(window).width() > 1024) {
          maxCard = parseInt($complementarySec.attr('data-slides'));
        }
        else {
          maxCard = 3;
        }
        var visibleWidth = cardWidth * Math.min(totalProducts, maxCard);
        var offset = ((containerWidth - visibleWidth) / 2);
        var leftOffset = offset - 5;
        var rightOffset = offset + 5;

        if($(window).width() > 1024) {
          $prevBtn.css('left', leftOffset + 'px');
          $nextBtn.css('right', rightOffset + 'px');

          if($productCards.length > maxCard) {
            $slider.addClass('.justify-left');
          }
        }

        clearInterval(intervalId);
      }
    }, 100);

  }
}
// end: complementary slider arrow pos

// start: gwp auto add
autoAddGwp = () => {
  var $gwps = $('.jsc-auto-gwp');

  if ($gwps.length === 0) return;

  var parseExcludedIds = function (attr) {
    if (!attr || typeof attr !== 'string') return [];
    return attr.split(',').map(function (id) {
      return parseInt(String(id).trim(), 10);
    }).filter(function (n) {
      return !isNaN(n);
    });
  };

  var cartJsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  var root = window.Shopify.routes.root;
  var drawerHintVid = parseInt($gwps.first().attr('data-vid'), 10);

  fetch(root + 'cart.js', {
    method: 'GET',
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var originalPrice = data.original_total_price;
      var updates = {};
      var pendingAddVid = {};
      var toAdd = [];

      $gwps.each(function () {
        var $el = $(this);
        var gwpVid = parseInt($el.attr('data-vid'), 10);
        var minSpend = parseInt($el.attr('data-min-spend'), 10);
        if (isNaN(gwpVid) || isNaN(minSpend)) return;

        var excludedProductIds = parseExcludedIds($el.attr('data-exclude-ids'));
        var excludedTotal = 0;
        data.items.forEach(function (item) {
          if (excludedProductIds.indexOf(item.id) !== -1) {
            excludedTotal += item.price * item.quantity;
          }
        });

        var finalTotal = originalPrice - excludedTotal;

        var gwpiInCart = data.items.find(function (item) {
          return item.id === gwpVid && item.properties && item.properties['_Promo'];
        });

        var gwpiInCartNoProperty = data.items.find(function (item) {
          return item.id === gwpVid && item.properties && !item.properties['_Promo'];
        });

        if (gwpiInCartNoProperty && gwpiInCartNoProperty.quantity > 0) {
          updates[gwpiInCartNoProperty.key] = 0;
        }

        if (finalTotal >= minSpend && !gwpiInCart) {
          if (!pendingAddVid[gwpVid]) {
            pendingAddVid[gwpVid] = true;
            toAdd.push(gwpVid);
          }
        } else if (finalTotal < minSpend && gwpiInCart) {
          updates[gwpiInCart.key] = 0;
        } else if (finalTotal >= minSpend && gwpiInCart && gwpiInCart.quantity > 1) {
          updates[gwpiInCart.key] = 1;
        }
      });

      var updateKeys = Object.keys(updates);
      var hasAdds = toAdd.length > 0;
      if (updateKeys.length === 0 && !hasAdds) return Promise.resolve(false);

      var hasRemovals = updateKeys.some(function (k) {
        return updates[k] === 0;
      });
      if (hasAdds || hasRemovals) {
        $('.jsc_cart__checkout').attr('disabled', true);
        $('.jsc_view__cart').attr('disabled', true);
      }

      var parseCartError = function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            throw new Error((body && body.message) || response.statusText || 'Cart request failed');
          });
      };

      var lastCartJson = null;

      var postUpdate = function () {
        if (updateKeys.length === 0) return Promise.resolve(null);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: cartJsonHeaders,
          body: JSON.stringify({ updates: updates }),
        }).then(function (response) {
          if (!response.ok) return parseCartError(response);
          return response.json();
        }).then(function (cart) {
          lastCartJson = cart;
          return cart;
        });
      };

      var postAdd = function () {
        if (!hasAdds) return Promise.resolve(null);
        var items = toAdd.map(function (vid) {
          return {
            id: vid,
            quantity: 1,
            properties: { _Promo: 'Free Gift' },
          };
        });
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: cartJsonHeaders,
          body: JSON.stringify({ items: items }),
        }).then(function (response) {
          if (!response.ok) return parseCartError(response);
          return response.json();
        }).then(function (cart) {
          lastCartJson = cart;
          return cart;
        });
      };

      return postUpdate()
        .then(function () {
          return postAdd();
        })
        .then(function () {
          if (lastCartJson) {
            try {
              $(document).trigger('cart.requestComplete', [lastCartJson]);
            } catch (e) {}
          }
          var drawerVid = hasAdds ? toAdd[toAdd.length - 1] : drawerHintVid;
          if (isNaN(drawerVid) && lastCartJson && lastCartJson.items && lastCartJson.items[0]) {
            drawerVid = lastCartJson.items[0].id;
          }
          if (isNaN(drawerVid)) drawerVid = null;
          return { ran: true, drawerVid: drawerVid };
        });
    })
    .then(function (result) {
      if (!result || !result.ran) return;
      removeCartSpinner();
      if (window.location.pathname === '/cart') {
        // location.reload();
        return;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      updateCartDrawer(result.drawerVid, cartDrawer);
      if (typeof checkGiftWrapInCartFast === 'function') {
        checkGiftWrapInCartFast();
      }
    })
    .catch(function (error) {
      removeCartSpinner();
      console.error('Error:', error);
    });
}
// end: gwp auto add

// start: buy x get y
buyXGetYGwp = () => {
  var _ele = $('.jsc-buy-x-get-y-gwp');
  

  if(_ele.length > 0) {
    _ele.each(function() {
      var _qualifier_vid = parseInt($(this).attr('data-qualifier-vid'));
      var _qualifier_qty = parseInt($(this).attr('data-qualifier-qty'));
      var _gift_vid = parseInt($(this).attr('data-gift-vid'));
      var _gift_qty = parseInt($(this).attr('data-gift-qty'));
      var _index = $(this).attr('data-loop');
      
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Find qualifoer item in cart
        var qualifier_item_in_cart = data.items.find(item => 
          item.id == _qualifier_vid
        );

        if (qualifier_item_in_cart !== undefined) {
          // Qualifier item in cart
          var qualifier_item_in_cart_qty = qualifier_item_in_cart.quantity;
          
          var complete_sets = Math.floor(qualifier_item_in_cart_qty / _qualifier_qty);
          var final_get_qty = complete_sets * _gift_qty;

          var gift_item_in_cart = data.items.find(item => 
            item.id == _gift_vid && item.properties['_index'] == _index
          );

          if (gift_item_in_cart !== undefined) {
            if (qualifier_item_in_cart_qty < _qualifier_qty) {
              cartJSUpdate(gift_item_in_cart.key, 0, {});
            }

            // Update exisiting gwp qty (ONLY USE FOR EVERY) e.g. For every 2 qualifier item, get 1 gwp, so buy 4 get 2 gwp. then uncomment the code below
            
            // var gift_item_in_cart_qty = gift_item_in_cart.quantity;
            // if (gift_item_in_cart_qty != final_get_qty) {
            //   $('.jsc_cart__checkout').attr('disabled',true);
            //   $('.jsc_view__cart').attr('disabled',true);
            //   cartJSUpdate(gift_item_in_cart.key, final_get_qty, {'_Promo': 'Free Gift', '_index': _index});
            // }

          } else {
            // Add gwp because it's not in cart
              $('.jsc_cart__checkout').attr('disabled',true);
              $('.jsc_view__cart').attr('disabled',true);
              
              if (qualifier_item_in_cart_qty >= _qualifier_qty) {
                cartJSAdd(_gift_vid, _gift_qty, {'_Promo': 'Free Gift', '_index': _index});
              }else{
                $('.jsc_cart__checkout').attr('disabled',false);
                $('.jsc_view__cart').attr('disabled',false);
              }

              // Uncomment the code below if the Promo is on Every Purchase
              // if (final_get_qty != 0) {
              //   cartJSAdd(_gift_vid, final_get_qty, {'_Promo': 'Free Gift', '_index': _index});
              // }
          }

        } else  {
          var gift_item_in_cart = data.items.find(item => 
            item.id == _gift_vid && item.properties['_index'] == _index
          );

          if (gift_item_in_cart !== undefined) {
            // if gwp is in cart but qualifier is not in cart then remove gwp
              $('.jsc_cart__checkout').attr('disabled',true);
              $('.jsc_view__cart').attr('disabled',true);
              cartJSUpdate(gift_item_in_cart.key, 0, {});
          }
        }

      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }
}
// end: buy x get y

// start: tier GWP
showCartSpinner = () => {
  $('.jsc_cart__checkout').attr('disabled',true);
  $('.jsc_view__cart').prop('outerHTML', $('.jsc_view__cart').prop('outerHTML').replace('<a', '<button').replace('</button>', '</span>'));
  $('.jsc_view__cart').attr('disabled', true);

  var cartItemElement = 'cart-drawer-items';

  // Check if we're on the cart page
  if (window.location.pathname == '/cart') {
    cartItemElement = 'cart-items';
  }

  $(`${cartItemElement}`).addClass('is-loading');

}
removeCartSpinner = () => {
  $('.jsc_cart__checkout').removeAttr('disabled');
  $('.jsc_view__cart').prop('outerHTML', $('.jsc_view__cart').prop('outerHTML').replace('<button', '<a').replace('</button>', '</a>'));
  $('.jsc_view__cart').removeAttr('disabled')
  var cartItemElement = 'cart-drawer-items';

  // Check if we're on the cart page
  if (window.location.pathname == '/cart') {
    cartItemElement = 'cart-items';
  }

  $(`${cartItemElement}`).removeClass('is-loading');

}

autoTierGwp = () => {
  var $tierGwps = $('.jsc-tier-gwp');
  if ($tierGwps.length === 0) return;

  var parseExcludedIds = function (attr) {
    if (!attr || typeof attr !== 'string') return [];
    return attr.split(',').map(function (id) {
      return parseInt(String(id).trim(), 10);
    }).filter(function (n) {
      return !isNaN(n);
    });
  };

  var cartJsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  var root = window.Shopify.routes.root;
  var tiers = {
    1: { minSpend: 0, vids: [] },
    2: { minSpend: 0, vids: [] },
    3: { minSpend: 0, vids: [] },
  };
  var excludedProductIds = parseExcludedIds($tierGwps.first().attr('data-exclude-vid'));

  $tierGwps.each(function () {
    var $el = $(this);
    var tier = parseInt($el.attr('data-tier'), 10);
    var vid = parseInt($el.attr('data-vid'), 10);
    if (isNaN(tier) || isNaN(vid) || !tiers[tier]) return;
    if (tiers[tier].vids.indexOf(vid) === -1) {
      tiers[tier].vids.push(vid);
    }
    tiers[tier].minSpend = parseInt($el.attr('data-min-spend'), 10);
  });

  var allTierVids = tiers[1].vids.concat(tiers[2].vids, tiers[3].vids);
  if (allTierVids.length === 0) return;

  fetch(root + 'cart.js', {
    method: 'GET',
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var originalPrice = data.original_total_price;
      var excludedTotal = 0;

      data.items.forEach(function (item) {
        if (excludedProductIds.indexOf(item.id) !== -1) {
          excludedTotal += item.price * item.quantity;
        }
      });
      originalPrice = originalPrice - excludedTotal;

      var activeTierVids = [];
      if (tiers[3].vids.length > 0 && originalPrice >= tiers[3].minSpend) {
        activeTierVids = tiers[3].vids;
      } else if (tiers[2].vids.length > 0 && originalPrice >= tiers[2].minSpend) {
        activeTierVids = tiers[2].vids;
      } else if (tiers[1].vids.length > 0 && originalPrice >= tiers[1].minSpend) {
        activeTierVids = tiers[1].vids;
      }

      var updates = {};
      var toAdd = [];
      var pendingAddVid = {};

      data.items.forEach(function (item) {
        if (allTierVids.indexOf(item.id) === -1) return;

        var hasPromo = item.properties && item.properties['_Promo'];
        var noPromo = item.properties && !item.properties['_Promo'];
        var isActive = activeTierVids.indexOf(item.id) !== -1;

        if (noPromo && item.quantity > 0) {
          updates[item.key] = 0;
          return;
        }

        if (!hasPromo) return;

        if (!isActive) {
          updates[item.key] = 0;
        } else if (item.quantity > 1) {
          updates[item.key] = 1;
        }
      });

      activeTierVids.forEach(function (vid) {
        var gwpiInCart = data.items.find(function (item) {
          return item.id === vid && item.properties && item.properties['_Promo'];
        });
        if (!gwpiInCart && !pendingAddVid[vid]) {
          pendingAddVid[vid] = true;
          toAdd.push(vid);
        }
      });

      var updateKeys = Object.keys(updates);
      var hasAdds = toAdd.length > 0;
      if (updateKeys.length === 0 && !hasAdds) return Promise.resolve(false);

      var hasRemovals = updateKeys.some(function (k) {
        return updates[k] === 0;
      });
      if (hasAdds || hasRemovals) {
        showCartSpinner();
      }

      var parseCartError = function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            throw new Error((body && body.message) || response.statusText || 'Cart request failed');
          });
      };

      var lastCartJson = null;

      var postUpdate = function () {
        if (updateKeys.length === 0) return Promise.resolve(null);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: cartJsonHeaders,
          body: JSON.stringify({ updates: updates }),
        }).then(function (response) {
          if (!response.ok) return parseCartError(response);
          return response.json();
        }).then(function (cart) {
          lastCartJson = cart;
          return cart;
        });
      };

      var postAdd = function () {
        if (!hasAdds) return Promise.resolve(null);
        var items = toAdd.map(function (vid) {
          return {
            id: vid,
            quantity: 1,
            properties: { _Promo: 'Free Gift' },
          };
        });
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: cartJsonHeaders,
          body: JSON.stringify({ items: items }),
        }).then(function (response) {
          if (!response.ok) return parseCartError(response);
          return response.json();
        }).then(function (cart) {
          lastCartJson = cart;
          return cart;
        });
      };

      return postUpdate()
        .then(function () {
          return postAdd();
        })
        .then(function () {
          if (lastCartJson) {
            try {
              $(document).trigger('cart.requestComplete', [lastCartJson]);
            } catch (e) {}
          }
          return {
            ran: true,
            drawerVid: hasAdds ? toAdd[toAdd.length - 1] : allTierVids[0],
          };
        });
    })
    .then(function (result) {
      if (!result || !result.ran) return;
      removeCartSpinner();
      if (window.location.pathname === '/cart') {
        // location.reload();
        return;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      updateCartDrawer(result.drawerVid, cartDrawer);
    })
    .catch(function (error) {
      removeCartSpinner();
      console.error('Error:', error);
    });
}
// end: tier GWP

// start: bundle product
updateBundleVariantOption = (evt) => {
  var variantId = parseInt($(evt).val());
  var $bundleWrap = $('.jsc-bundle-variant-picker').find(`.jsc-bundle-variant-option-wrap[data-main-var-id="${variantId}"]`);
  
  $bundleWrap.siblings('.jsc-bundle-variant-option-wrap').removeClass('active');
  $bundleWrap.addClass('active');
  var $defaultOption = $bundleWrap.find('.jsc-bundle-variant-option:not(.oos)').first();
  if ($defaultOption.length == 0) {
    $defaultOption = $bundleWrap.find('.jsc-bundle-variant-option').first();
  }
  $defaultOption.click();
}

updateBundleVariant = (evt) => {
  var $input = $(evt).find('input[name="jsc-bundle-variant-check"]');
  $input.prop('checked', true);

  // update price
  var priceMoney = $($(evt).attr('price-money')).text();
  $(evt).closest('.product__content').find('.price__regular .money').text(priceMoney);

  // update button
  var isAvailable = $(evt).attr('is-available');
  var bundleAtcBtn = $('.bundle-product__form');
  var bundleBisBtn = $('.bundle-product-bis');
  if (isAvailable == 'true') {
    bundleAtcBtn.css('display', 'grid');
    bundleBisBtn.css('display', 'none');
  }
  else {
    bundleAtcBtn.css('display', 'none');
    bundleBisBtn.css('display', 'inline-block');
  }

  // update smile widget
  var isBundle = $(evt).attr('is-bundle');
  var $fakeSmileWidget = $('.jsc-fake-smile-widget');
  var $appSmileWidget = $fakeSmileWidget.prev('.shopify-app-block');
  if ($appSmileWidget.length > 0) {
    if (isBundle != undefined) {
      var points = parseInt($(evt).attr('product-points'));
      if (points > 0) {
        var isLogin = $fakeSmileWidget.attr('data-customer');
        if (isLogin == 'true') {
          $fakeSmileWidget.find('.jsc-smile-widget-label').html(`Earn ${points} Points when you buy this item.`);
        }
        else {
          $fakeSmileWidget.find('.jsc-smile-widget-label').html(`Members earn ${points} Points when they buy this item. <a href="/account/register/">Sign up</a> or <a href="/account/login/">log in.</a>`);
        }
        $fakeSmileWidget.addClass('show');
      }
      $appSmileWidget.hide();
    }
    else {
      $fakeSmileWidget.removeClass('show');
      $appSmileWidget.show();
    }
  }

  updateBundleMedia($(evt), isBundle);

  // update klaviyo form info
  var $klaviyoForm = $(evt).parents('.jsc-bundle-variant-picker').siblings('.jsc-email-form-modal');
  var $klaviyoButton = $klaviyoForm.find('.jsc-email-form-btn');
  var $klaviyoTitle = $klaviyoForm.find('.jsc-email-form-title');
  var productId = parseInt($(evt).attr('product-id'));
  var productName = $(evt).attr('product-name');
  var variantId = parseInt($(evt).attr('variant-id'));
  var variantName = $(evt).attr('variant-name');
  var variantSku = $(evt).attr('variant-sku');
  var price = parseInt($(evt).attr('price'));

  $klaviyoTitle.text(productName);
  $klaviyoButton.attr('data-product-id', productId);
  $klaviyoButton.attr('data-product-name', productName);
  $klaviyoButton.attr('data-vid', variantId);
  $klaviyoButton.attr('data-variant-name', variantName);
  $klaviyoButton.attr('data-sku', variantSku);
  $klaviyoButton.attr('data-price', price);
}

bundleAtc = (evt) => {
  var $checkedInput = $(evt).closest('.product__content').find('.jsc-bundle-variant-picker .jsc-bundle-variant-option-wrap.active input[name="jsc-bundle-variant-check"]:checked');
  if ($checkedInput.length > 0) {
    var id = parseInt($checkedInput.val());
    var qty = parseInt($(evt).parent('.bundle-product__form').find('.product-selector__quantity .quantity__input').val());
    cartJSAdd(id, qty, {});
  }
}

openEmailForm = () => {
  var emailModal = $('.jsc-email-form-modal');
  emailModal.show();
}

closeEmailForm = () => {
  var emailModal = $('.jsc-email-form-modal');
  emailModal.hide();
}

triggerKlaviyo = (e) => {
  // email input validation
  var email = $(e).siblings('.jsc-email-form-field').find('.jsc-email-input').val();
  var subscriptionCheck = $(e).siblings('#newsletter_subscription').find('#subscribe_for_newsletter');
  var validationMessage = $(e).siblings('.jsc-email-validation');
  var isEmailValid = false;
  if(email.length <= 0) {
    validationMessage.text('Please fill in your email address');
    validationMessage.show();
  }
  else {
    var emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (emailRegex.test(email)) {
      validationMessage.hide();
      isEmailValid = true;
    } else {
      validationMessage.text('Please fill a valid email address');
      validationMessage.show();
    }
  }

  // get product data
  if(isEmailValid == true) {
    var productId = $(e).data('product-id');
    var productName = $(e).data('product-name');
    var vid = $(e).data('vid');
    var variantName = $(e).data('variant-name');
    var sku = $(e).data('sku');
    var price = $(e).data('price');

    var item = {
      "ProductID": productId,
      "ProductName": productName,
      "Categories": [],
      "platform": "Shopify",
      "Channels": [
        "EMAIL"
      ],
      "VariantId": vid,
      "VariantName": variantName,
      "SKU": sku,
      "Price": price
    };

    klaviyo.push(['identify', {'$email' : email}]); // determine profile
    klaviyo.push(['track', 'Back in Stock Subscription', item]); // track profile activity

    if (subscriptionCheck.prop('checked')) {
      const subscribePayload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": email,
                  "properties": {
                    "newKey": "New Value"
                  }
                },
                "meta": {
                  "patch_properties": {
                    "append": {
                      "newKey": "New Value"
                    },
                    "unappend": {
                      "newKey": "New Value"
                    }
                  }
                }
              }
            }
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": "TX6b9m"
              }
            }
          }
        }
      }

      var subscribeOption = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-07-15"
        },
        body: JSON.stringify(subscribePayload),
      };

      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=wHzJ88",subscribeOption)
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
    }

    var submitMessage = $('.jsc-submission-success');
    submitMessage.show();
    $(e).hide();
  }
}

updateBundleMedia = (current_variant, isBundle) => {
  var titleAlt = $(current_variant).attr('product-name').toLowerCase();
  var titleVarAlt = titleAlt + '-' + $(current_variant).attr('variant-name').toLowerCase();
  var $thumbnail_list = $(current_variant).closest('.product__grid').find('.swiper-thumbs-container .swiper-slide'); 

  if (isBundle != undefined) {
    $thumbnail_list.each(function() {
      var mediaAlt = $(this).attr('data-media-alt').toLowerCase();
      if(mediaAlt == titleAlt || mediaAlt == titleVarAlt) {
        var productMedia = document.querySelector('product-media');
        var featuredMediaId = $(this).attr('data-media-id');

        if (productMedia && featuredMediaId) {
          productMedia.setActiveMedia(Number(featuredMediaId));
          return false;
        }
      }
    });
  }
  else {
    var mediaId = $(current_variant).attr('media-id');
    $thumbnail_list.each(function() {
      if($(this).attr('data-media-id') == mediaId) {
        var productMedia = document.querySelector('product-media');
        var featuredMediaId = $(this).attr('data-media-id');

        if (productMedia && featuredMediaId) {
          productMedia.setActiveMedia(Number(featuredMediaId));
          return false;
        }
      }
    });
  }
}
// end: bundle product

// start: gwp sample progress bar
updateMilestonePosition = () => {
  var $progressContainer = $('.jsc-gwp-sample__progress-container');
  if ($progressContainer.length > 0) {
    $progressContainer.each(function() {
      var $milestone = $(this).find('.jsc-gwp-sample-progress__milestone');
      var milestoneCount = $milestone.length;
      
      // space-evenly in center part
      // $milestone.each(function(index) {
      //   var leftValue = ((index + 1) / (milestoneCount + 1)) * 100;
      //   $(this).css('left', leftValue + '%');
      // });
  
      // distribute between 85% length
      // var spacing = 85.0 / milestoneCount;
      // $milestone.each(function(index) {
      //   var leftValue = (index + 1) * spacing;
      //   $(this).css('left', leftValue + '%');
      // });

      var positions = {
        1: [50],
        2: [30, 70],
        3: [20, 50, 80]
      };

      if (positions[milestoneCount]) {
        $milestone.each(function(index) {
          $(this).css('left', positions[milestoneCount][index] + '%');
        });
      }
    });
  }
}

updateGwpSamppleProgress = () => {
  var $progressContainer = $('.jsc-gwp-sample__progress-container');
  if ($progressContainer.length > 0) {
    fetch(window.Shopify.routes.root + 'cart.js',  {
      method: 'GET'
    })
    .then(response => {
      return response.json();
    })
    .then(cart => {
      var cartTotal = cart.original_total_price;

      var currTierCount = parseInt($('.__gwpsample-currenttier_countleft:last').attr('data-count'));
      var currTierCountLeft = parseInt($('.__gwpsample-currenttier_countleft:last').attr('data-countleft'));
    
      if ((currTierCountLeft < 0) || (currTierCount < 1)) {
        var gwpKeylist = $('.__remove-allgwp').attr('data-gwpKeylist');
        if (gwpKeylist){
          removeAllGwpSample(gwpKeylist);
        }
      }

      $progressContainer.each(function(index, $progressCont) {
        var $milestones = $($progressCont).find('.jsc-gwp-sample-progress__milestone');
        $milestones.each(function() {
          var threshold = parseInt($(this).attr('threshold'));
          if (cartTotal >= threshold) {
            $(this).addClass('active');
          }
          else {
            $(this).removeClass('active');
          }
        });

        var $lastActiveMilestone = $($progressCont).find('.jsc-gwp-sample-progress__milestone.active:last');
        // var cartTotal = parseInt($progressContainer.attr('cart-total'));
        var $progressBar = $($progressCont).find('.jsc-gwp-sample-progress__progress');
        var $progressMessage = $($progressCont).find('.jsc-gwp-sample-progress__message');
        var $progressInfo = $($progressCont).find('.jsc-gwp-sample-progress__info-wrap');
        var progress = 0;

        if ($lastActiveMilestone.length > 0) {
          var threshold = parseInt($lastActiveMilestone.attr('threshold'));
          var leftValue = parseFloat($lastActiveMilestone.css('left'));
          var $nextMilestone = $lastActiveMilestone.next('.jsc-gwp-sample-progress__milestone');

          if ($nextMilestone.length == 0) {
            progress = '100%';
            $progressMessage.hide();
          }
          else {
            if (cartTotal > threshold) {
              var nextMilestoneLeftValue = parseInt($nextMilestone.css('left'));
              var nextThreshold = parseInt($nextMilestone.attr('threshold'));
              var amountOverCurrentThreshold = cartTotal - threshold;
              var diffToNextThreshold = nextThreshold - threshold;
              var milestonePercentage = amountOverCurrentThreshold / diffToNextThreshold;
              var middleValue = (nextMilestoneLeftValue - leftValue) * milestonePercentage;

              var temp = leftValue + middleValue;
              progress = temp + 'px';
            }
            else {
              progress = leftValue + 'px';
            }

            // update message
            var remainingAmount = ((nextThreshold - cartTotal) / 100).toFixed(2);
            if ($nextMilestone.is('[free-shipping]')) {
              $progressMessage.text(`You are $${remainingAmount} away from Free Shipping`);
            }
            else if ($nextMilestone.is('[gwp-sample]')) {
              var sample = parseInt($nextMilestone.attr('sample'));
              if (sample == 1) {
                $progressMessage.text(`You are $${remainingAmount} away from ${sample} Complimentary Sample`);
              }
              else {
                $progressMessage.text(`You are $${remainingAmount} away from ${sample} Complimentary Samples`);
              }
            }
            $progressMessage.show();
          }
        }
        else {
          var $firstMilestone = $($progressCont).find('.jsc-gwp-sample-progress__milestone:first');
          if ($firstMilestone.length > 0) {
            var leftValue = parseFloat($firstMilestone.css('left'));
            var threshold = parseInt($firstMilestone.attr('threshold'));
            var milestonePercentage = cartTotal / threshold;
            var temp = leftValue * milestonePercentage;
            progress = temp + 'px';

            // update message
            var remainingAmount = ((threshold - cartTotal) / 100).toFixed(2);
            if ($firstMilestone.is('[free-shipping]')) {
              $progressMessage.text(`You are $${remainingAmount} away from Free Shipping`);
            }
            else if ($firstMilestone.is('[gwp-sample]')) {
              var sample = parseInt($firstMilestone.attr('sample'));
              if (sample == 1) {
                $progressMessage.text(`You are $${remainingAmount} away from ${sample} Complimentary Sample`);
              }
              else {
                $progressMessage.text(`You are $${remainingAmount} away from ${sample} Complimentary Samples`);
              }
            }
            $progressMessage.show();
          }
        }

        $progressBar.css('width', progress);

        // update bottom info
        var $milestones = $($progressCont).find('.jsc-gwp-sample-progress__milestone');
        $milestones.each(function() {
          if ($(this).is('[free-shipping]')) {
            if ($(this).hasClass('active')) {
              $progressInfo.find('.jsc-gwp-sample-progress__info[free-shipping]').addClass('active');
            }
            else {
              $progressInfo.find('.jsc-gwp-sample-progress__info[free-shipping]').removeClass('active');
            }
          }
          else if ($(this).is('[tier-1]')) {
            if ($(this).hasClass('active')) {
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-1]').addClass('active');
            }
            else {
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-1]').removeClass('active');
            }
          }
          else if ($(this).is('[tier-2]')) {
            if ($(this).hasClass('active')) {
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-2]').addClass('active');
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-1]').removeClass('active');
            }
            else {
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-2]').removeClass('active');
            }
          }
        });
      });

      gwpSampleDropdown();
    });
  }
}
// end: gwp sample progress bar

// start: toggle complementary slider arrow
toggleComplementaryArrow = () => {
  var $section = $('.section-complete-the-set');
  if ($section.length > 0) {
    var $slider = $section.find('complementary-products .card-product-slider__wrapper');
    var $arrows = $section.find('.swiper-buttons');
    setTimeout(() => {
      console.log('timeout toggle arrow', $arrows);
      if ($slider.children().length > 0) {
        $arrows.removeClass('hide');
      }
    }, 1500);
  }
}
// end: toggle complementary slider arrow

enableSliderButton = () => {
  setTimeout(() => {
    var $slider = $('card-slider');
    if ($slider.length > 0) {
      $slider.siblings('.swiper-button--next').removeClass('swiper-button-disabled');
    }
  }, 1000);
}

// Start: gwp collection min qty
gwpColMinCartQty = () => {
  setTimeout(() => {
    var $gwpInfo = $('.jsc-gwp-min-cart-qty');
    if ($gwpInfo.length === 0) return;

    var $accumulate_qty = 0;
    var $purchase_qty = parseInt($gwpInfo.attr('purchaseQty'), 10);
    var $gift_inventory = parseInt($gwpInfo.attr('gift-inventory'), 10);
    var $giftHandle = $gwpInfo.attr('gift-handle');
    var $giftVid = parseInt($gwpInfo.attr('gift-vid'), 10);

    if (isNaN($purchase_qty) || $purchase_qty <= 0) return;

    $('.jsc-cart-item-qtycol').each(function() {
      var $item_qty = parseInt($(this).find('.cart-item__quantity .quantity__input').val(), 10);
      if (!isNaN($item_qty)) {
        $accumulate_qty += $item_qty;
      }
    });

    var $gift_qty = Math.floor($accumulate_qty / $purchase_qty);
    if ($gift_qty > 0) {
      $gift_qty = 1;
    }

    // If gift is unavailable, force target qty to 0 to clean up stale promo gifts.
    if (isNaN($gift_inventory) || $gift_inventory <= 0) {
      $gift_qty = 0;
    }

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        var promoGiftItems = (cart.items || []).filter(item => {
          var $productProps = item.properties || {};
          if ($productProps['_Promo'] != 'Free Gift') return false;

          var itemVid = parseInt(item.id, 10);
          if (!isNaN($giftVid) && itemVid == $giftVid) return true;
          return item.handle == $giftHandle;
        });

        // Not eligible anymore: remove all matching promo gift line items.
        if ($gift_qty <= 0) {
          promoGiftItems.forEach(item => {
            cartJSUpdate(item.key, 0, {});
          });
          return;
        }

        if (promoGiftItems.length === 0) {
          if (!isNaN($giftVid)) {
            cartJSAdd($giftVid, $gift_qty, {'_Promo': 'Free Gift'});
          }
          return;
        }

        // Keep exactly one valid promo line with the expected qty, remove duplicates.
        var primaryGift = promoGiftItems[0];
        if (primaryGift.quantity != $gift_qty) {
          cartJSUpdate(primaryGift.key, $gift_qty, {});
        }

        if (promoGiftItems.length > 1) {
          promoGiftItems.slice(1).forEach(item => {
            cartJSUpdate(item.key, 0, {});
          });
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }, 500);
}
// End: gwp collection min qty

// start: klaviyoFormHeadingUpdate;
klaviyoFormHeadingUpdate = () => {
  const newsletterHeader = $('#newsletter__header');
  const newsletterHeaderLoggedIn = $('#newsletter__loggedin');
  const klaviyoOnsite = localStorage.getItem('klaviyoOnsite');
  // console.log('klaviyoOnsite: ', klaviyoOnsite);
  if (klaviyoOnsite) {
    const parsedValue = JSON.parse(klaviyoOnsite);
    // console.log('XDgXWf parsedValue', parsedValue);
    const isDisabled = parsedValue.viewedForms.modal.disabledForms.hasOwnProperty('XDgXWf');
    console.log('XDgXWf isDisabled', isDisabled);

    if (isDisabled) {
      if (newsletterHeader.length > 0) { newsletterHeader.css('display', 'none'); }
      if (newsletterHeaderLoggedIn.length > 0) { newsletterHeaderLoggedIn.css('display', 'block'); }
    }
  }
}

/** Scroll only the grid variant strip; never scrollIntoView (avoids nudging parent carousels / page). */
jscScrollGridVariantPillIntoViewport = btn => {
  const viewport = btn.closest('.jsc-grid-variant-selector-viewport');
  if (!viewport) {
    return;
  }

  const pad = 4;
  const btnRect = btn.getBoundingClientRect();
  const vpRect = viewport.getBoundingClientRect();

  if (btnRect.right > vpRect.right - pad) {
    viewport.scrollLeft += Math.ceil(btnRect.right - vpRect.right + pad);
  } else if (btnRect.left < vpRect.left + pad) {
    viewport.scrollLeft -= Math.ceil(vpRect.left - btnRect.left + pad);
  }
};

jscUpdateGridCardVariantPrice = (root, btn) => {
  const card = root.closest('card-product') || root.closest('.card-product');
  if (!card) {
    return;
  }

  const priceEl = card.querySelector('.card-product__price');
  if (!priceEl) {
    return;
  }

  const priceFormatted = btn.getAttribute('data-price-formatted');
  const compareFormatted = btn.getAttribute('data-compare-formatted') || '';
  if (!priceFormatted) {
    return;
  }

  const container = priceEl.querySelector('.price__container') || priceEl;
  const onSale = compareFormatted !== '';

  if (onSale) {
    priceEl.classList.add('price--on-sale');

    const regularBlock = container.querySelector('.price__regular');
    if (regularBlock) {
      regularBlock.remove();
    }

    let saleBlock = container.querySelector('.price__sale');
    if (!saleBlock) {
      saleBlock = document.createElement('div');
      saleBlock.className = 'price__sale';
      saleBlock.innerHTML =
        '<div class="price__sale-inner"><span class="visually-hidden"></span><del><span class="money"></span></del><span class="visually-hidden"></span><ins><span class="money"></span></ins></div>';
      container.appendChild(saleBlock);
    }

    const del = saleBlock.querySelector('del');
    const ins = saleBlock.querySelector('ins');
    if (del) {
      (del.querySelector('.money') || del).textContent = compareFormatted;
    }
    if (ins) {
      (ins.querySelector('.money') || ins).textContent = priceFormatted;
    }
  } else {
    priceEl.classList.remove('price--on-sale');

    const saleBlock = container.querySelector('.price__sale');
    if (saleBlock) {
      saleBlock.remove();
    }

    let regularBlock = container.querySelector('.price__regular');
    if (!regularBlock) {
      regularBlock = document.createElement('div');
      regularBlock.className = 'price__regular';
      regularBlock.innerHTML =
        '<span class="visually-hidden"></span><span><span class="money"></span></span>';
      container.appendChild(regularBlock);
    }

    const priceSpan = regularBlock.querySelector('span:not(.visually-hidden)');
    if (priceSpan) {
      (priceSpan.querySelector('.money') || priceSpan).textContent = priceFormatted;
    }
  }
};

jscUpdateCartOnlyUpsellVariantPrice = (detailsEl, btn) => {
  if (!detailsEl) {
    return;
  }

  const priceEl = detailsEl.querySelector('.cart-recommendations__item-price');
  if (!priceEl) {
    return;
  }

  const priceFormatted = btn.getAttribute('data-price-formatted');
  const compareFormatted = btn.getAttribute('data-compare-formatted') || '';
  if (!priceFormatted) {
    return;
  }

  const container = priceEl.querySelector('.price__container') || priceEl;
  const onSale = compareFormatted !== '';

  if (onSale) {
    priceEl.classList.add('price--on-sale');

    const regularBlock = container.querySelector('.price__regular');
    if (regularBlock) {
      regularBlock.remove();
    }

    let saleBlock = container.querySelector('.price__sale');
    if (!saleBlock) {
      saleBlock = document.createElement('div');
      saleBlock.className = 'price__sale';
      saleBlock.innerHTML =
        '<div class="price__sale-inner"><span class="visually-hidden"></span><del><span class="money"></span></del><span class="visually-hidden"></span><ins><span class="money"></span></ins></div>';
      container.appendChild(saleBlock);
    }

    const del = saleBlock.querySelector('del');
    const ins = saleBlock.querySelector('ins');
    if (del) {
      (del.querySelector('.money') || del).textContent = compareFormatted;
    }
    if (ins) {
      (ins.querySelector('.money') || ins).textContent = priceFormatted;
    }
  } else {
    priceEl.classList.remove('price--on-sale');

    const saleBlock = container.querySelector('.price__sale');
    if (saleBlock) {
      saleBlock.remove();
    }

    let regularBlock = container.querySelector('.price__regular');
    if (!regularBlock) {
      regularBlock = document.createElement('div');
      regularBlock.className = 'price__regular';
      regularBlock.innerHTML =
        '<span class="visually-hidden"></span><span><span class="money"></span></span>';
      container.appendChild(regularBlock);
    }

    const priceSpan = regularBlock.querySelector('span:not(.visually-hidden)');
    if (priceSpan) {
      (priceSpan.querySelector('.money') || priceSpan).textContent = priceFormatted;
    }
  }
};

jscCartOnlyUpsellVariantPillClick = (btn, event) => {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  if (btn.disabled) {
    return;
  }

  const root = btn.closest('[data-jsc-cart-only-upsell-card]');
  if (!root) {
    return;
  }

  const variantId = btn.getAttribute('data-variant-id');

  root.querySelectorAll('.jsc-grid-variant-pill').forEach(pill => {
    const isThis = pill === btn;
    pill.classList.toggle('is-selected', isThis);
    pill.setAttribute('aria-pressed', isThis ? 'true' : 'false');
  });

  root.querySelectorAll('.jsc-cart-only-upsell-variant-cta').forEach(cta => {
    const isMatch = cta.getAttribute('data-variant-id') === variantId;
    cta.classList.toggle('jsc-cart-only-upsell-variant-cta--hidden', !isMatch);
  });

  const detailsEl = root.closest('.cart-recommendations__item-details');
  jscUpdateCartOnlyUpsellVariantPrice(detailsEl, btn);
  jscScrollGridVariantPillIntoViewport(btn);
};

jscGridCardVariantPillClick = (btn, event) => {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const root = btn.closest('[data-jsc-grid-card]');
  if (!root) {
    return;
  }

  const variantId = btn.getAttribute('data-variant-id');
  const available = btn.getAttribute('data-available') === 'true';

  root.querySelectorAll('.jsc-grid-variant-pill').forEach(pill => {
    const isThis = pill === btn;
    pill.classList.toggle('is-selected', isThis);
    pill.setAttribute('aria-pressed', isThis ? 'true' : 'false');
  });

  const atc = root.querySelector('.jsc-grid-card-atc-cta');
  const notify = root.querySelector('.jsc-grid-card-notify-cta');
  if (atc) {
    atc.setAttribute('variant-id', variantId);
  }
  if (notify) {
    notify.setAttribute('variant-id', variantId);
  }

  if (atc && notify) {
    if (available) {
      atc.classList.remove('jsc-grid-card-cta--hidden');
      notify.classList.add('jsc-grid-card-cta--hidden');
    } else {
      atc.classList.add('jsc-grid-card-cta--hidden');
      notify.classList.remove('jsc-grid-card-cta--hidden');
    }
  }

  jscUpdateGridCardVariantPrice(root, btn);
  jscScrollGridVariantPillIntoViewport(btn);
};

jscInitGridVariantPillScroll = (root = document) => {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.jsc-grid-variant-pill.is-selected').forEach(pill => {
    jscScrollGridVariantPillIntoViewport(pill);
  });
};

/** Click-drag + wheel horizontal scroll for variant pill strips (all product grids). */
jscInitGridVariantDragScroll = (root = document) => {
  const scope = root && root.querySelectorAll ? root : document;
  const DRAG_THRESHOLD = 6;

  scope.querySelectorAll('.jsc-grid-variant-selector-viewport:not([data-jsc-variant-drag-scroll])').forEach(viewport => {
    viewport.dataset.jscVariantDragScroll = 'true';

    let activePointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let isDragging = false;
    let suppressPillClick = false;

    const endDrag = e => {
      if (activePointerId === null || e.pointerId !== activePointerId) {
        return;
      }

      suppressPillClick = isDragging;
      isDragging = false;
      activePointerId = null;
      viewport.classList.remove('is-dragging');

      try {
        if (viewport.hasPointerCapture(e.pointerId)) {
          viewport.releasePointerCapture(e.pointerId);
        }
      } catch (err) {
        /* ignore */
      }
    };

    viewport.addEventListener(
      'click',
      e => {
        if (!suppressPillClick || !e.target.closest('.jsc-grid-variant-pill')) {
          return;
        }

        suppressPillClick = false;
        e.preventDefault();
        e.stopImmediatePropagation();
      },
      true
    );

    viewport.addEventListener(
      'pointerdown',
      e => {
        if (e.button !== 0) {
          return;
        }

        suppressPillClick = false;
        activePointerId = e.pointerId;
        startX = e.clientX;
        startScrollLeft = viewport.scrollLeft;
        isDragging = false;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'pointermove',
      e => {
        if (activePointerId === null || e.pointerId !== activePointerId) {
          return;
        }

        const dx = e.clientX - startX;

        if (!isDragging) {
          if (Math.abs(dx) <= DRAG_THRESHOLD) {
            return;
          }
          isDragging = true;
          viewport.classList.add('is-dragging');
          try {
            viewport.setPointerCapture(e.pointerId);
          } catch (err) {
            /* ignore */
          }
        }

        e.preventDefault();
        viewport.scrollLeft = startScrollLeft - dx;
      },
      { passive: false }
    );

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    viewport.addEventListener(
      'wheel',
      e => {
        if (viewport.scrollWidth <= viewport.clientWidth + 1) {
          return;
        }

        const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (!delta) {
          return;
        }

        viewport.scrollLeft += delta;
        e.preventDefault();
      },
      { passive: false }
    );
  });
};

jscInitGridVariantPillScrollInContext = (root = document) => {
  jscInitGridVariantPillScroll(root);
  jscInitGridVariantDragScroll(root);
};

anchorLink = (evt) => {
  var anchorLink = $(evt).attr('anchor-link');
  if (anchorLink) {
    var $pdpPage = $(evt).parents('#MainContent');
    if ($pdpPage.length > 0) {
      var $tab = $(`.section-how-to-use[anchor-link="${anchorLink}"]`);
      console.log($tab);
      if ($tab.length > 0) {
        window.scrollTo({
          top: $tab.offset().top - 150,
          behavior: 'smooth'
        });
      }
    }
  }
}
// end: klaviyoFormHeadingUpdate();

gridATCFast = (evt, event) => {
  event.stopPropagation();
  event.preventDefault();
  
  var variantId = parseInt($(evt).attr('variant-id'));
  cartJSAdd(variantId, 1, {});
}

// Custom Klaviyo BIS Functions

showBisForm = (e) => {
  var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
  var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');
  var $title = $modal.find('.jsc-bis-title');
  var $selector = $modal.find('.jsc-bis-variant-selector');
  var $emailInput = $modal.find('.jsc-bis-email');
  var $message = $modal.find('.jsc-bis-message');
  var productJson = JSON.parse($(e).attr('data-product'));

  // Get current selected variant from the AI block's hidden input
  var currentVariantId = null;
  var $aiBlock = $(e).closest('[class*="ai-parent-featured-product"]');
  if ($aiBlock.length) {
    // Find the variant input using the jsc-selected-variant class
    var $variantInput = $aiBlock.find('.jsc-selected-variant');
    if ($variantInput.length) {
      currentVariantId = $variantInput.val();
    }
  }
  

  $title.text(productJson.title);
  $selector.html('');
  $.each(productJson.variants, function() {
    if(this.available == false) {
      var $option = $('<option></option>').val(this.id).text(this.title);
              // Pre-select the current variant if it's sold out
              if (currentVariantId && this.id == currentVariantId) {
                $option.prop('selected', true);
              }
      $selector.append($option);
    }
  });
  $emailInput.val('');
  $message.removeClass('show');

  $overlay.addClass('active');
  $modal.addClass('active');
}

hideBisForm = () => {
  var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
  var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');

  $overlay.removeClass('active');
  $modal.removeClass('active');
}

subscribeBIS = (e) => {
  var emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  var email = $(e).parents('.jsc-bis-form-modal').find('.jsc-bis-email').val();
  var isEmailValid = false;
  var vid = parseInt($(e).parents('.jsc-bis-form-modal').find('.jsc-bis-variant-selector').val());
  var $message = $(e).parents('.jsc-bis-form-modal').find('.jsc-bis-message');
  var $listCheck = $(e).parents('.jsc-bis-form-modal').find('.jsc-list-checkbox');

  if (emailRegex.test(email)) {
    isEmailValid = true;
    $message.removeClass('show');
  }
  else {
    $message.html('Please input a valid email');
    $message.addClass('jsc-bis-error');
    $message.addClass('show');
  }

  if(isEmailValid == true) {
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": "$shopify:::$default:::" + vid
            }
          }
        }
      }
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision":"2024-06-15"
      },
      body: JSON.stringify(payload),
    };

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=wHzJ88",requestOptions)
      .then(result => {
        console.log(result);
        $message.html("You're in! We'll let you know when it's back. <span onclick='hideBisForm();'>Close</span>");
        $message.addClass('jsc-bis-success');
        $message.addClass('show');
      })
      .catch(error => {
        console.log('error', error);
        $message.html("Error occurred! <span onclick='hideBisForm();'>Close</span>");
        $message.addClass('jsc-bis-error');
        $message.addClass('show');
      });

    if($listCheck.is(':checked')) {
      // Use Klaviyo's track method for email list subscription
      if (typeof klaviyo !== 'undefined') {
        klaviyo.push(['track', 'Subscribe to List', {
          '$email': email,
          'source': 'back_in_stock_form'
        }]);
        
        // Also try to identify the profile
        klaviyo.push(['identify', {
          '$email': email
        }]);
      }
    }
  }
}

// start: Klaviyo BIS from collection page or product grid
showBisFormFromGrid = (e,event) => {
  event.stopPropagation();
  event.preventDefault();
  var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
  var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');
  var $title = $modal.find('.jsc-bis-title');
  var $selector = $modal.find('.jsc-bis-variant-selector');
  var $emailInput = $modal.find('.jsc-bis-email');
  var $message = $modal.find('.jsc-bis-message');
  var productTitle = $(e).attr('product-title');
  var variantID = $(e).attr('variant-id');

  $title.text(productTitle);
  $selector.html('');
  $selector.append($('<option></option>').val(variantID).text(productTitle).prop('selected', true));
  $emailInput.val('');
  $message.removeClass('show');

  $overlay.addClass('active');
  $modal.addClass('active');
}
// end: Klaviyo BIS from collection page or product grid

// start: cart gift wrap
/** Returns the active product variant panel within a gift-wrap block. */
getActiveGiftWrapPanel = ($cont) => {
  if (!$cont || !$cont.length) return $();
  var productId = $cont.attr('product-id');
  if (!productId) return $();
  return $cont.find('.jsc-cart-gift-wrap-product-variant-panel[data-product-id="' + productId + '"]');
};

/** Variant info inputs for the currently selected gift-wrap product. */
getGiftWrapVariantInfoForProduct = ($cont) => {
  var productId = $cont.attr('product-id');
  if (!productId) return $();
  return $cont.find('.jsc-cart-gift-wrap-variant-info[data-product-id="' + productId + '"]');
};

resetGiftWrapToDefaultProduct = ($cont) => {
  if (!$cont || !$cont.length) return;
  var defaultProductId = $cont.attr('data-default-product-id');
  if (!defaultProductId) return;
  var $defaultTab = $cont.find('.jsc-cart-gift-wrap-product-option[data-product-id="' + defaultProductId + '"]').not('.gift-wrap-oos').first();
  if ($defaultTab.length) {
    switchGiftWrapProduct($defaultTab[0]);
    return;
  }
  $cont.attr('product-id', defaultProductId);
  $cont.find('.jsc-cart-gift-wrap-product-variant-panel').addClass('d-none');
  $cont.find('.jsc-cart-gift-wrap-product-variant-panel[data-product-id="' + defaultProductId + '"]').removeClass('d-none');
};

updateGiftWrapImage = ($cont, imgSrc) => {
  if (!$cont || !$cont.length || !imgSrc) return;
  var $img = $cont.find('.jsc-cart-gift-wrap-image img');
  if (!$img.length) return;
  $img.attr('src', imgSrc);
  $img.attr('srcset', imgSrc + ' 1000w');
};

updateGiftWrapDisplayImage = ($cont) => {
  if (!$cont || !$cont.length) return;
  var isChecked = $cont.find('.jsc-cart-gift-wrap-checkbox').is(':checked');
  var placeholder = $cont.attr('data-placeholder-image');
  if (!isChecked && placeholder) {
    updateGiftWrapImage($cont, placeholder);
    return;
  }
  var $activeProduct = $cont.find('.jsc-cart-gift-wrap-product-option.active').first();
  var imgSrc = $activeProduct.attr('data-image') || $cont.attr('data-default-product-image');
  if (imgSrc) updateGiftWrapImage($cont, imgSrc);
};

switchGiftWrapProduct = (evt) => {
  if ($(evt).hasClass('gift-wrap-oos')) {
    return;
  }
  var $cont = $(evt).closest('.jsc-cart-gift-wrap-cont');
  var productId = $(evt).attr('data-product-id');
  var imgSrc = $(evt).attr('data-image');
  var defPrice = $(evt).attr('data-default-price');
  var productTitle = $(evt).attr('data-product-title') || $(evt).text().trim();

  $cont.find('.jsc-cart-gift-wrap-product-option').removeClass('active');
  $(evt).addClass('active');
  $cont.attr('product-id', productId);

  if (productTitle) {
    $cont.find('.jsc-cart-gift-wrap-product-current-value').text(productTitle);
  }

  if (imgSrc && $cont.find('.jsc-cart-gift-wrap-checkbox').is(':checked')) {
    updateGiftWrapImage($cont, imgSrc);
  }

  $cont.find('.jsc-cart-gift-wrap-product-variant-panel').addClass('d-none');
  $cont.find('.jsc-cart-gift-wrap-product-variant-panel[data-product-id="' + productId + '"]').removeClass('d-none');

  var $priceEl = $cont.find('.jsc-cart-gift-wrap-price');
  if (defPrice) {
    $priceEl.attr('data-default-price', defPrice);
  }

  var $panel = getActiveGiftWrapPanel($cont);
  $panel.find('.jsc-cart-gift-wrap-option:not(.jsc-cart-gift-wrap-product-option)').removeClass('active');
  $panel.find('.jsc-cart-gift-wrap-current-value').text('');

  giftWrapPreselectFirstOptionRowIfSingle($cont);
  updateGiftWrapVariantOption($cont);
  updateGiftWrapDisplayedPrice($cont);
};

/** When option position 1 has a single value, select it (matches Liquid default; restores after checkbox clears). */
giftWrapPreselectFirstOptionRowIfSingle = ($cont) => {
  if (!$cont || !$cont.length) return;
  var $panel = getActiveGiftWrapPanel($cont);
  var $row = $panel.find('.jsc-cart-gift-wrap-variant-picker-wrap[index="1"]');
  if (!$row.length) return;
  var $options = $row.find('.jsc-cart-gift-wrap-option').filter(function () {
    return !$(this).hasClass('d-none');
  });
  if ($options.length !== 1) return;
  if ($row.find('.jsc-cart-gift-wrap-option.active').length) return;
  var $opt = $options.first();
  if ($opt.hasClass('gift-wrap-oos')) return;
  updateGiftWrapVariant($opt[0]);
};

toggleGiftWrapVariantPicker = (evt) => {
  var $cont = $(evt).closest('.jsc-cart-gift-wrap-cont');
  var $variantPicker = $cont.find('.jsc-cart-gift-wrap-variant-picker');
  var $optionValueText = $variantPicker.find('.jsc-cart-gift-wrap-current-value');
  var $variantOption = $variantPicker.find('.jsc-cart-gift-wrap-option');
  if ($(evt).is(':checked')) {
    $variantPicker.removeClass('d-none');
    giftWrapPreselectFirstOptionRowIfSingle($cont);
    if (getActiveGiftWrapPanel($cont).find('.jsc-cart-gift-wrap-option.active').length) {
      updateGiftWrapVariantOption($cont);
    }
    updateGiftWrapDisplayedPrice($cont);
    updateGiftWrapDisplayImage($cont);
  }
  else {
    giftWrapCartAddLocked = false;
    if (giftWrapUnlockFallbackTimer) {
      clearTimeout(giftWrapUnlockFallbackTimer);
      giftWrapUnlockFallbackTimer = null;
    }
    $(document).off('cart.requestComplete.giftwrapaddlock', giftWrapUnlockAfterAdd);
    $variantPicker.addClass('d-none');
    $optionValueText.text('');
    $variantOption.not('.jsc-cart-gift-wrap-product-option').removeClass('active');
    resetGiftWrapToDefaultProduct($cont);
    var $priceEl = $cont.find('.jsc-cart-gift-wrap-price');
    var def = $priceEl.attr('data-default-price');
    if (def) {
      $priceEl.html(def);
    }
    updateGiftWrapDisplayImage($cont);
  }
}

updateGiftWrapVariant = (evt) => {
  if ($(evt).hasClass('gift-wrap-oos')) {
    return;
  }
  var $optionWrap = $(evt).parents('.jsc-cart-gift-wrap-option-wrap');
  var value = $(evt).attr('data-value');
  var $optionValueText = $optionWrap.parents('.jsc-cart-gift-wrap-variant-picker-wrap').find('.jsc-cart-gift-wrap-current-value');
  $optionWrap.find('.jsc-cart-gift-wrap-option:not(.jsc-cart-gift-wrap-product-option)').removeClass('active');
  $(evt).addClass('active');
  $optionValueText.text(value);
  var $giftWrapCont = $(evt).closest('.jsc-cart-gift-wrap-cont');
  updateGiftWrapVariantOption($giftWrapCont);
  updateGiftWrapDisplayedPrice($giftWrapCont);
  if ($giftWrapCont.find('.jsc-cart-gift-wrap-checkbox').is(':checked')) {
    giftWrapATC($(evt));
  }
}

getGiftWrapOption = () => {
  var $giftWrapCont = $('.jsc-cart-gift-wrap-cont');
  var $variantPickerWrap = $giftWrapCont.find('.jsc-cart-gift-wrap-variant-picker-wrap');
  var option1, option2, option3 = null;

  $variantPickerWrap.each(function(index, $variantPicker) {
    var position = $($variantPicker).attr('index');
    var $options = $($variantPicker).find('.jsc-cart-gift-wrap-option');
    
    $options.each(function(index, $option) {
      if ($($option).hasClass('active')) {
        if (position == 1) {
          option1 = $($option).attr('data-value');
        }
        else if (position == 2) {
          option2 = $($option).attr('data-value');
        }
        else if (position == 3) {
          option3 = $($option).attr('data-value');
        }
      }
    });
  });

  return {
    option1: option1,
    option2: option2,
    option3: option3
  }
}

/** Selected option values for one gift-wrap block (scoped; safe when drawer + page both exist). */
getGiftWrapOptionIn = ($cont) => {
  var option1 = null;
  var option2 = null;
  var option3 = null;
  getActiveGiftWrapPanel($cont).find('.jsc-cart-gift-wrap-variant-picker-wrap').each(function () {
    var position = $(this).attr('index');
    $(this).find('.jsc-cart-gift-wrap-option').each(function () {
      var $option = $(this);
      if ($option.hasClass('active')) {
        if (position == 1) option1 = $option.attr('data-value');
        else if (position == 2) option2 = $option.attr('data-value');
        else if (position == 3) option3 = $option.attr('data-value');
      }
    });
  });
  return { option1: option1, option2: option2, option3: option3 };
}

/** True when every option row in this block has a selected (.active) value. */
giftWrapAllOptionRowsSelected = ($cont) => {
  var $rows = getActiveGiftWrapPanel($cont).find('.jsc-cart-gift-wrap-variant-picker-wrap');
  if ($rows.length === 0) return false;
  var all = true;
  $rows.each(function () {
    if ($(this).find('.jsc-cart-gift-wrap-option.active').length === 0) {
      all = false;
      return false;
    }
  });
  return all;
};

/** Shows variant price only when every option is selected; otherwise the default (min) product price from data-default-price. */
updateGiftWrapDisplayedPrice = ($cont) => {
  if (!$cont || !$cont.length) return;
  var $priceEl = $cont.find('.jsc-cart-gift-wrap-price');
  var def = $priceEl.attr('data-default-price');
  if (!giftWrapAllOptionRowsSelected($cont)) {
    if (def) {
      $priceEl.html(def);
    }
    return;
  }
  var optionInfo = getGiftWrapOptionIn($cont);
  var opt1Value = optionInfo.option1 || '';
  var opt2Value = optionInfo.option2 || '';
  var opt3Value = optionInfo.option3 || '';
  var $match = getGiftWrapVariantInfoForProduct($cont).filter(function () {
    var $variant = $(this);
    var varOpt1 = $variant.attr('option-1') || '';
    var varOpt2 = $variant.attr('option-2') || '';
    var varOpt3 = $variant.attr('option-3') || '';
    return varOpt1 === opt1Value && varOpt2 === opt2Value && varOpt3 === opt3Value;
  }).first();
  if (!$match.length) {
    if (def) {
      $priceEl.html(def);
    }
    return;
  }
  var formatted = $match.attr('data-variant-price-formatted') || '';
  $priceEl.html(formatted);
};

updateGiftWrapVariantOption = ($cont) => {
  if (!$cont || !$cont.length) return;
  var optionInfo = getGiftWrapOptionIn($cont);
  var $variantInfo = getGiftWrapVariantInfoForProduct($cont);
  var $panel = getActiveGiftWrapPanel($cont);
  var $variantPickerWrap = $panel.find('.jsc-cart-gift-wrap-variant-picker-wrap');
  
  // Filter using OR logic: include variants that match ANY non-null option value
  var $filteredVariants = $variantInfo.filter(function() {
    var $element = $(this);
    var matches = false;
    
    // Check if element matches option1 (if option1 has a value)
    if (optionInfo.option1 != null && $element.attr('option-1') === optionInfo.option1) {
      matches = true;
    }
    
    // Check if element matches option2 (if option2 has a value)
    if (optionInfo.option2 != null && $element.attr('option-2') === optionInfo.option2) {
      matches = true;
    }
    
    // Check if element matches option3 (if option3 has a value)
    if (optionInfo.option3 != null && $element.attr('option-3') === optionInfo.option3) {
      matches = true;
    }
    
    return matches;
  });

  // First, show all options in the active panel
  $panel.find('.jsc-cart-gift-wrap-option:not(.jsc-cart-gift-wrap-product-option)').removeClass('d-none');
  
  // Get all variants with hide-variant="true" (impossible combinations)
  var $hiddenVariants = $variantInfo.filter(function() {
    return $(this).attr('hide-variant') === 'true';
  });
  
  // For each impossible variant, hide options that would create that combination
  $hiddenVariants.each(function(index, variant) {
    var $variant = $(variant);
    var varOpt1 = $variant.attr('option-1');
    var varOpt2 = $variant.attr('option-2');
    var varOpt3 = $variant.attr('option-3');
    
    // Check if current selection matches any part of this impossible variant
    var matchesOption1 = optionInfo.option1 != null && optionInfo.option1 === varOpt1;
    var matchesOption2 = optionInfo.option2 != null && optionInfo.option2 === varOpt2;
    var matchesOption3 = optionInfo.option3 != null && optionInfo.option3 === varOpt3;
    
    // If any option matches, hide the other options from this impossible variant
    if (matchesOption1 || matchesOption2 || matchesOption3) {
      $variantPickerWrap.each(function(index, variantPicker) {
        var $variantPicker = $(variantPicker);
        var position = parseInt($variantPicker.attr('index'));
        var $variantOptions = $variantPicker.find('.jsc-cart-gift-wrap-option');
        
        $variantOptions.each(function(index, option) {
          var $option = $(option);
          var optionValue = $option.attr('data-value');
          var isCurrentlySelected = $option.hasClass('active');
          
          // Don't hide the currently selected option
          if (isCurrentlySelected) {
            return;
          }
          
          // Hide option-2 if we've selected option-1 that matches this impossible variant
          if (position == 2 && varOpt2 === optionValue && matchesOption1) {
            $option.addClass('d-none');
          }
          // Hide option-3 if we've selected option-1 that matches this impossible variant
          else if (position == 3 && varOpt3 === optionValue && matchesOption1) {
            $option.addClass('d-none');
          }
          // Hide option-1 if we've selected option-2 that matches this impossible variant
          else if (position == 1 && varOpt1 === optionValue && matchesOption2) {
            $option.addClass('d-none');
          }
          // Hide option-3 if we've selected option-2 that matches this impossible variant
          else if (position == 3 && varOpt3 === optionValue && matchesOption2) {
            $option.addClass('d-none');
          }
          // Hide option-1 if we've selected option-3 that matches this impossible variant
          else if (position == 1 && varOpt1 === optionValue && matchesOption3) {
            $option.addClass('d-none');
          }
          // Hide option-2 if we've selected option-3 that matches this impossible variant
          else if (position == 2 && varOpt2 === optionValue && matchesOption3) {
            $option.addClass('d-none');
          }
        });
      });
    }
  });
  
  // First, remove all out-of-stock classes in the active panel
  $panel.find('.jsc-cart-gift-wrap-option:not(.jsc-cart-gift-wrap-product-option)').removeClass('gift-wrap-oos');
  
  // Get all variants with variant-available="false" (out of stock)
  var $unavailableVariants = $variantInfo.filter(function() {
    return $(this).attr('variant-available') === 'false';
  });
  
  // For each unavailable variant, mark options that would create that combination as out of stock
  $unavailableVariants.each(function(index, variant) {
    var $variant = $(variant);
    var varOpt1 = $variant.attr('option-1');
    var varOpt2 = $variant.attr('option-2');
    var varOpt3 = $variant.attr('option-3');
    
    // Check if current selection matches any part of this unavailable variant
    var matchesOption1 = optionInfo.option1 != null && optionInfo.option1 === varOpt1;
    var matchesOption2 = optionInfo.option2 != null && optionInfo.option2 === varOpt2;
    var matchesOption3 = optionInfo.option3 != null && optionInfo.option3 === varOpt3;
    
    // If any option matches, mark the other options from this unavailable variant as out of stock
    if (matchesOption1 || matchesOption2 || matchesOption3) {
      $variantPickerWrap.each(function(index, variantPicker) {
        var $variantPicker = $(variantPicker);
        var position = parseInt($variantPicker.attr('index'));
        var $variantOptions = $variantPicker.find('.jsc-cart-gift-wrap-option');
        
        $variantOptions.each(function(index, option) {
          var $option = $(option);
          var optionValue = $option.attr('data-value');
          var isCurrentlySelected = $option.hasClass('active');
          
          // Don't mark the currently selected option as out of stock
          if (isCurrentlySelected) {
            return;
          }
          
          // Mark option-2 as out of stock if we've selected option-1 that matches this unavailable variant
          if (position == 2 && varOpt2 === optionValue && matchesOption1) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-3 as out of stock if we've selected option-1 that matches this unavailable variant
          else if (position == 3 && varOpt3 === optionValue && matchesOption1) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-1 as out of stock if we've selected option-2 that matches this unavailable variant
          else if (position == 1 && varOpt1 === optionValue && matchesOption2) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-3 as out of stock if we've selected option-2 that matches this unavailable variant
          else if (position == 3 && varOpt3 === optionValue && matchesOption2) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-1 as out of stock if we've selected option-3 that matches this unavailable variant
          else if (position == 1 && varOpt1 === optionValue && matchesOption3) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-2 as out of stock if we've selected option-3 that matches this unavailable variant
          else if (position == 2 && varOpt2 === optionValue && matchesOption3) {
            $option.addClass('gift-wrap-oos');
          }
        });
      });
    }
  });
}

/** Prevents rapid gift-wrap variant clicks from enqueueing multiple cart adds before the drawer/cart updates. */
var giftWrapCartAddLocked = false;
var giftWrapUnlockFallbackTimer;

giftWrapUnlockAfterAdd = () => {
  if (giftWrapUnlockFallbackTimer) {
    clearTimeout(giftWrapUnlockFallbackTimer);
    giftWrapUnlockFallbackTimer = null;
  }
  $(document).off('cart.requestComplete.giftwrapaddlock', giftWrapUnlockAfterAdd);
  giftWrapCartAddLocked = false;
};

giftWrapATC = (evt) => {
  var $cont = $(evt).closest('.jsc-cart-gift-wrap-cont');
  var $variantPickerWrap = getActiveGiftWrapPanel($cont).find('.jsc-cart-gift-wrap-variant-picker-wrap');
  var hasEmptyOption = false;

  $variantPickerWrap.each(function(index, variantPicker) {
    var $variantPicker = $(variantPicker);
    var $variantOptions = $variantPicker.find('.jsc-cart-gift-wrap-option');
    var valueSelected = false;

    $variantOptions.each(function(index, option) {
      var $option = $(option);
      if ($option.hasClass('active')) {
        valueSelected = true;
      }
    });

    if (valueSelected == false) {
      hasEmptyOption = true;
    }
  });

  if (hasEmptyOption == false) {
    if (giftWrapCartAddLocked) {
      return;
    }
    var productId = $cont.attr('product-id');
    var productIds = ($cont.attr('data-product-ids') || '').split(',').filter(Boolean);
    if (productIds.length) {
      var anyGiftWrapInCart = productIds.some(function (id) {
        return $('.cart-item.is-gift-wrap[data-product-id="' + id + '"]').length > 0;
      });
      if (anyGiftWrapInCart) {
        return;
      }
    } else if (productId && $('.cart-item.is-gift-wrap[data-product-id="' + productId + '"]').length > 0) {
      return;
    }
    var optionInfo = getGiftWrapOptionIn($cont);
    var $allVariantInfo = getGiftWrapVariantInfoForProduct($cont);
    
    // Filter to find variant that matches all optionInfo values
    // If optionInfo value is blank, the variant's corresponding option must also be blank
    var $variantInfo = $allVariantInfo.filter(function() {
      var $variant = $(this);
      var varOpt1 = $variant.attr('option-1') || '';
      var varOpt2 = $variant.attr('option-2') || '';
      var varOpt3 = $variant.attr('option-3') || '';
      
      var opt1Value = optionInfo.option1 || '';
      var opt2Value = optionInfo.option2 || '';
      var opt3Value = optionInfo.option3 || '';
      
      // Check if all options match
      var matchesOption1 = varOpt1 === opt1Value;
      var matchesOption2 = varOpt2 === opt2Value;
      var matchesOption3 = varOpt3 === opt3Value;
      
      return matchesOption1 && matchesOption2 && matchesOption3;
    });
    
    var variantId = $variantInfo.attr('variant-id');
    if (!variantId) {
      return;
    }
    giftWrapCartAddLocked = true;
    if (giftWrapUnlockFallbackTimer) {
      clearTimeout(giftWrapUnlockFallbackTimer);
    }
    $(document).one('cart.requestComplete.giftwrapaddlock', giftWrapUnlockAfterAdd);
    giftWrapUnlockFallbackTimer = setTimeout(giftWrapUnlockAfterAdd, 4000);
    cartJSAdd(variantId, 1, {});
  }
}

// Debounce function to prevent multiple rapid calls (only for cart page)
var checkGiftWrapInCartTimeout;
var lastCheckTime = 0;
var CHECK_DEBOUNCE_DELAY = 500; // Minimum time between checks

// Fast DOM-based check for cart drawer
checkGiftWrapInCartFast = () => {
  $('.jsc-cart-gift-wrap-section').each(function () {
    var $section = $(this);
    var $cont = $section.find('.jsc-cart-gift-wrap-cont');
    var productIds = ($cont.attr('data-product-ids') || '').split(',').filter(Boolean);
    if (!productIds.length) return;

    var productInCart = productIds.some(function (id) {
      return $('.cart-item.is-gift-wrap[data-product-id="' + id + '"]').length > 0;
    });

    if (productInCart) {
      $section.addClass('d-none');
    } else {
      $section.removeClass('d-none');
    }
  });
}

// Debounced API-based check for cart page (slower but more reliable)
checkGiftWrapInCart = () => {
  // Use fast check for cart drawer, API check for cart page
  if (window.location.pathname !== '/cart') {
    checkGiftWrapInCartFast();
    return;
  }
  
  var $giftWrapSections = $('.jsc-cart-gift-wrap-section');
  
  if ($giftWrapSections.length === 0) {
    return;
  }
  
  // Clear any pending timeout
  if (checkGiftWrapInCartTimeout) {
    clearTimeout(checkGiftWrapInCartTimeout);
  }
  
  // Debounce: only run if enough time has passed since last check
  var now = Date.now();
  var timeSinceLastCheck = now - lastCheckTime;
  var delay = timeSinceLastCheck < CHECK_DEBOUNCE_DELAY ? CHECK_DEBOUNCE_DELAY - timeSinceLastCheck : 0;
  
  checkGiftWrapInCartTimeout = setTimeout(() => {
    lastCheckTime = Date.now();
    
    // Fetch cart state directly from API instead of relying on DOM
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    })
    .then(response => {
      return response.json();
    })
    .then(cart => {
      $('.jsc-cart-gift-wrap-section').each(function () {
        var $section = $(this);
        var $cont = $section.find('.jsc-cart-gift-wrap-cont');
        var productIds = ($cont.attr('data-product-ids') || '').split(',').filter(Boolean);
        if (!productIds.length) return;

        var productInCart = productIds.some(function (id) {
          var productIdNum = parseInt(id, 10);
          return cart.items.some(function (item) {
            return item.product_id === productIdNum;
          });
        });

        if (productInCart) {
          $section.addClass('d-none');
        } else {
          $section.removeClass('d-none');
        }
      });
    })
    .catch(error => {
      console.error('Error checking gift wrap in cart:', error);
      // Fallback to DOM check if API fails
      checkGiftWrapInCartFast();
    });
  }, delay);
}

// Listen for all cart updates
$(document).on('cart.requestComplete', function(event, cart) {
  // Fast check for cart drawer, delayed API check for cart page
  if (window.location.pathname === '/cart') {
    setTimeout(() => {
      checkGiftWrapInCart();
    }, 1500);
  } else {
    // Fast DOM check for cart drawer
    setTimeout(() => {
      checkGiftWrapInCartFast();
    }, 100);
  }
});

// Also listen for cart changes (for cart page updates only)
$(document).on('cart:updated', function() {
  // Only apply to cart page
  if (window.location.pathname === '/cart') {
    setTimeout(() => {
      checkGiftWrapInCart();
    }, 1500);
  }
});
// end: cart gift wrap

// start: remove invalid free items from cart
removeInvalidFreeItems = () => {
  var runCleanup = () => {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    var items = data.items || [];

    var invalidFreeItems = items.filter(item => {
      var props = item.properties || {};
      return item.original_line_price <= 0 && !props['_Promo'] && !props['_GWP Sample'];
    });

    var qualifyingNonPromoItems = items.filter(item => {
      var props = item.properties || {};
      return !props['_Promo'] && !props['_GWP Sample'] && item.original_line_price > 0;
    });

    // Safety cleanup: if cart has no qualifying non-promo items left,
    // remove stale promo gifts so cart cannot be left with only _Promo freebies.
    var orphanPromoItems = [];
    if (qualifyingNonPromoItems.length === 0) {
      orphanPromoItems = items.filter(item => {
        var props = item.properties || {};
        return props['_Promo'] == 'Free Gift';
      });
    }

    var removeKeys = new Set();
    invalidFreeItems.forEach(item => removeKeys.add(item.key));
    orphanPromoItems.forEach(item => removeKeys.add(item.key));

    if(removeKeys.size > 0) {
      for (var itemKey of removeKeys) {
        cartJSUpdate(itemKey, 0); 
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  };

  runCleanup();

  if (window.__jscRemoveInvalidFreeItemsBound) return;
  window.__jscRemoveInvalidFreeItemsBound = true;
  $(document).on('cart.requestComplete cart:updated', function() {
    setTimeout(runCleanup, 200);
  });
}
// end: remove invalid free items from cart

// Desktop search: full-bleed panel; inner row aligns to .header__nav (section-header.css vars on #header)
var HEADER_SEARCH_DESKTOP_MIN = 990;
var headerSearchPanelResizeRaf = null;
var headerSearchNavResizeObserver = null;

disconnectHeaderSearchNavObserver = () => {
  if (headerSearchNavResizeObserver) {
    headerSearchNavResizeObserver.disconnect();
    headerSearchNavResizeObserver = null;
  }
}

/** Primary menu link strip (ul); not full-width <nav> when nav uses justify-content:center on the row. */
getHeaderNavMeasureEl = () => {
  var nav = document.querySelector('.header__nav.js-nav');
  if (!nav || nav.offsetWidth <= 0) return null;
  var strip = nav.querySelector(':scope > .header__nav-items');
  if (strip && strip.offsetWidth > 0) return strip;
  return nav;
}

connectHeaderSearchNavObserver = () => {
  disconnectHeaderSearchNavObserver();
  if (typeof ResizeObserver === 'undefined') return;
  var header = document.getElementById('header');
  if (!header) return;
  headerSearchNavResizeObserver = new ResizeObserver(function () {
    scheduleHeaderSearchPanelSync();
  });
  headerSearchNavResizeObserver.observe(header);
  var measureEl = getHeaderNavMeasureEl();
  if (measureEl) headerSearchNavResizeObserver.observe(measureEl);
}

clearHeaderSearchPanelVars = () => {
  disconnectHeaderSearchNavObserver();
  var header = document.getElementById('header');
  if (!header) return;
  header.style.removeProperty('--header-search-panel-top');
  header.style.removeProperty('--header-search-panel-left');
  header.style.removeProperty('--header-search-panel-width');
  header.style.removeProperty('--header-search-panel-right');
}

setHeaderSearchPanelVar = (header, name, value) => {
  if (header.style.getPropertyValue(name) === value) return;
  header.style.setProperty(name, value);
}

syncHeaderSearchPanelToNav = () => {
  if (typeof window === 'undefined' || window.innerWidth < HEADER_SEARCH_DESKTOP_MIN) {
    clearHeaderSearchPanelVars();
    return;
  }
  var details = document.getElementById('Search-drawer-header');
  if (
    !details ||
    !details.hasAttribute('open') ||
    !details.classList.contains('menu-opening')
  ) {
    clearHeaderSearchPanelVars();
    return;
  }
  var header = document.getElementById('header');
  if (!header) return;
  var docEl = document.documentElement;
  var clientW = docEl.clientWidth;

  var headerRect = header.getBoundingClientRect();
  setHeaderSearchPanelVar(
    header,
    '--header-search-panel-top',
    Math.round(headerRect.bottom) + 'px'
  );

  var measureEl = getHeaderNavMeasureEl();
  if (measureEl) {
    var r = measureEl.getBoundingClientRect();
    var left = Math.round(r.left);
    var width = Math.round(r.width);
    var rightSpace = Math.max(0, Math.round(clientW - r.right));
    setHeaderSearchPanelVar(header, '--header-search-panel-left', left + 'px');
    setHeaderSearchPanelVar(header, '--header-search-panel-width', width + 'px');
    setHeaderSearchPanelVar(header, '--header-search-panel-right', rightSpace + 'px');
  } else {
    var w = Math.min(960, Math.floor(clientW * 0.9));
    var leftFallback = Math.max(0, Math.floor((clientW - w) / 2));
    setHeaderSearchPanelVar(header, '--header-search-panel-width', w + 'px');
    setHeaderSearchPanelVar(header, '--header-search-panel-left', leftFallback + 'px');
    setHeaderSearchPanelVar(
      header,
      '--header-search-panel-right',
      Math.max(0, clientW - leftFallback - w) + 'px'
    );
  }
}

function scheduleHeaderSearchPanelSync() {
  if (typeof window === 'undefined') return;
  if (headerSearchPanelResizeRaf) cancelAnimationFrame(headerSearchPanelResizeRaf);
  headerSearchPanelResizeRaf = requestAnimationFrame(function () {
    headerSearchPanelResizeRaf = null;
    if (window.innerWidth < HEADER_SEARCH_DESKTOP_MIN) {
      clearHeaderSearchPanelVars();
      return;
    }
    var details = document.getElementById('Search-drawer-header');
    if (
      details &&
      details.hasAttribute('open') &&
      details.classList.contains('menu-opening')
    ) {
      syncHeaderSearchPanelToNav();
    }
  });
}

openSearchDrawer = evt => {
  requestAnimationFrame(function () {
    var isDesktop = window.innerWidth >= HEADER_SEARCH_DESKTOP_MIN;
    var $drawerContent = $(evt).find('#Search-menu-drawer-header');

    if (evt.hasAttribute('open')) {
      $(evt).addClass('menu-opening');

      var $searchHeaderButton = $(evt).find('#Search-drawer-button-header');
      $searchHeaderButton.addClass('menu-is-open');
      $searchHeaderButton.attr('role', 'button');
      $searchHeaderButton.attr('aria-controls', 'Search-menu-drawer-header');
      $searchHeaderButton.attr('aria-expanded', true);

      if (isDesktop) {
        syncHeaderSearchPanelToNav();
        connectHeaderSearchNavObserver();
        requestAnimationFrame(function () {
          syncHeaderSearchPanelToNav();
          requestAnimationFrame(syncHeaderSearchPanelToNav);
        });
        $drawerContent.css('opacity', '');
        $drawerContent.css('visibility', '');
        $drawerContent.css('transform', '');
      } else {
        disconnectHeaderSearchNavObserver();
        $drawerContent.css('opacity', 1);
        $drawerContent.css('visibility', 'visible');
        $drawerContent.css('transform', 'none');
      }
    } else {
      $(evt).removeClass('menu-opening');
      if (isDesktop) {
        clearHeaderSearchPanelVars();
        $drawerContent.css('opacity', '');
        $drawerContent.css('visibility', '');
        $drawerContent.css('transform', '');
      }
    }
  });
};

updateCartNote = (evt) => {
  var cartNote = $(evt).val();
  CartJS.setNote(cartNote);
}

/** start::
 * Desktop collection filter sidebar (1025px+): toggle on Filter tab click.
 * Below 1025px the default menu-drawer behaviour is unchanged.
 */
(function () {
  const DESKTOP_MIN = 1025;

  const isDesktop = () => window.innerWidth >= DESKTOP_MIN;

  const closeFacetsDrawer = drawer => {
    if (!drawer) return;

    const details = drawer.querySelector('details');
    if (!details) return;

    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    document.body.style.overflow = '';

    drawer.querySelectorAll('.menu-is-open').forEach(btn => {
      btn.classList.remove('menu-is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  };

  const init = () => {
    const collection = document.querySelector('.collection--filters-sidebar');
    if (!collection) return;

    const inner = collection.querySelector('.collection__inner');
    const filterBtn = collection.querySelector(
      '.jsc-facets__drawer summary.drawer__button'
    );
    const drawer = collection.querySelector('.jsc-facets__drawer');

    if (!inner || !filterBtn) return;

    filterBtn.addEventListener(
      'click',
      e => {
        if (!isDesktop()) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const isOpen = inner.classList.toggle('is-filters-open');
        filterBtn.setAttribute('aria-expanded', isOpen);
        filterBtn.classList.toggle('menu-is-open', isOpen);
      },
      true
    );

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (isDesktop()) {
          closeFacetsDrawer(drawer);
          return;
        }

        inner.classList.remove('is-filters-open');
        filterBtn.setAttribute('aria-expanded', 'false');
        filterBtn.classList.remove('menu-is-open');
      }, 150);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// end:: Desktop collection filter sidebar

// start: gwp sample dropdown layout
getGwpSampleTierMaxCount = () => {
  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length === 0) return null;

  var currTierCount = parseInt($marker.attr('data-count'), 10);
  if (Number.isNaN(currTierCount) || currTierCount <= 0) return null;

  var $tier1Milestone = $('.jsc-gwp-sample-progress__milestone[tier-1]:first');
  var $tier2Milestone = $('.jsc-gwp-sample-progress__milestone[tier-2]:first');
  var tier1Count = $tier1Milestone.length ? parseInt($tier1Milestone.attr('sample'), 10) : 1;
  var tier2Count = $tier2Milestone.length ? parseInt($tier2Milestone.attr('sample'), 10) : 2;

  if (Number.isNaN(tier1Count)) tier1Count = 1;
  if (Number.isNaN(tier2Count)) tier2Count = 2;

  var sampleCount = tier1Count;

  if (currTierCount === tier2Count) {
    sampleCount = tier2Count;
  } else if (currTierCount === tier1Count) {
    sampleCount = tier1Count;
  } else if (currTierCount >= tier2Count) {
    sampleCount = tier2Count;
  }

  return sampleCount;
}

getGwpSampleSelectedCount = () => {
  var maxCount = getGwpSampleTierMaxCount();
  if (maxCount == null) return null;

  var countLeft = getGwpSampleCountLeft();
  if (countLeft == null) return null;

  var selected = maxCount - countLeft;
  return selected < 0 ? 0 : selected;
}

updateGwpSampleDropdownStatus = () => {
  var $section = $('.jsc-gwpsample-section:first');
  if ($section.length === 0) return;

  var maxCount = getGwpSampleTierMaxCount();
  if (maxCount == null) return;

  var selected = getGwpSampleSelectedCount();
  if (selected == null) selected = 0;

  var $statusValue = $section.find('.jsc-cart-sample-dropdown-status-value:first');
  if ($statusValue.length > 0) {
    $statusValue.text(selected + '/' + maxCount);
  }

  var $clearBtn = $section.find('.jsc-cart-sample-dropdown-clear:first');
  if ($clearBtn.length > 0) {
    var keylist = $('.__remove-allgwp:last').attr('data-gwpkeylist') ||
      $('.__remove-allgwp:last').attr('data-gwpKeylist') ||
      $clearBtn.attr('data-gwp-keylist') ||
      '';

    if (keylist) {
      $clearBtn.attr('data-gwp-keylist', keylist);
    }

    if (selected > 0 && keylist) {
      $clearBtn.removeAttr('hidden');
    } else {
      $clearBtn.attr('hidden', true);
    }
  }
}

updateGwpSampleDropdownTabSelected = () => {
  var $section = $('.jsc-gwpsample-section:first');
  if ($section.length === 0) return;

  var $container = $section.find('.jsc-cart-sample-dropdown__tab-selected:first');
  var $tabLabel = $section.find('.jsc-cart-sample-dropdown__tab-label:first');
  if ($container.length === 0) return;

  var maxCount = getGwpSampleTierMaxCount();
  var chips = [];

  $section.find('.jsc-cart-sample-dropdown-row.is-selected').each(function() {
    var vid = $(this).attr('data-vid');
    var title = $(this).find('.jsc-cart-sample-dropdown-row__title:first').text().trim();

    if (!vid || !title) return;

    var exists = chips.some(function(chip) {
      return chip.vid === vid;
    });

    if (!exists) {
      chips.push({ vid: vid, title: title });
    }
  });

  $container.empty();

  if (chips.length === 0) {
    if ($tabLabel.length > 0) {
      if (maxCount != null) {
        $tabLabel.text('Select your sample (Max ' + maxCount + ' total)');
      }
      $tabLabel.removeAttr('hidden');
    }
    $container.attr('hidden', true);
    return;
  }

  if ($tabLabel.length > 0) {
    $tabLabel.attr('hidden', true);
  }
  $container.removeAttr('hidden');

  chips.forEach(function(chip) {
    var $chip = $('<span class="jsc-cart-sample-dropdown__tab-chip"></span>').attr('data-vid', chip.vid);
    $chip.append($('<span class="jsc-cart-sample-dropdown__tab-chip-title"></span>').text(chip.title));
    $chip.append(
      $('<button type="button" class="jsc-cart-sample-dropdown__tab-chip-remove"></button>')
        .attr('data-vid', chip.vid)
        .attr('aria-label', 'Remove ' + chip.title)
        .html('&times;')
    );
    $container.append($chip);
  });
}

gwpSampleDropdown = () => {
  var $section = $('.jsc-gwpsample-section:first');
  if ($section.length === 0) return;

  var sampleCount = getGwpSampleTierMaxCount();
  if (sampleCount == null) return;

  var $header = $section.find('.jsc-cart-sample-dropdown-header:first');
  if ($header.length > 0) {
    $header.text(
      'Select your ' + sampleCount + ' free sample' + (sampleCount === 1 ? '' : 's') + '.'
    );
  }

  updateGwpSampleDropdownStatus();
  updateGwpSampleDropdownTabSelected();
}

bindGwpSampleDropdownEvents = () => {
  if (window.__jscGwpSampleDropdownBound) return;
  window.__jscGwpSampleDropdownBound = true;

  var toggleGwpSampleDropdownTab = ($tab) => {
    var $dropdown = $tab.closest('.jsc-cart-sample-dropdown');
    var $panel = $dropdown.find('.jsc-cart-sample-dropdown__panel:first');
    var isOpen = $tab.attr('aria-expanded') === 'true';

    $tab.attr('aria-expanded', isOpen ? 'false' : 'true');
    $dropdown.toggleClass('is-open', !isOpen);

    if (isOpen) {
      $panel.attr('hidden', true);
    } else {
      $panel.removeAttr('hidden');
    }
  };

  $(document).on('click', '.jsc-cart-sample-dropdown__tab', function(e) {
    if ($(e.target).closest('.jsc-cart-sample-dropdown__tab-chip-remove').length) return;

    toggleGwpSampleDropdownTab($(this));
  });

  $(document).on('keydown', '.jsc-cart-sample-dropdown__tab', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    toggleGwpSampleDropdownTab($(this));
  });

  $(document).on('change', '.jsc-cart-sample-dropdown__checkbox', function() {
    setGwpSampleManualOverride();
    var $checkbox = $(this);
    var vid = $checkbox.attr('data-vid');

    if ($checkbox.is(':checked')) {
      if ($checkbox.is(':disabled')) {
        $checkbox.prop('checked', false);
        return;
      }

      gwpSampleAtc(this);
      return;
    }

    gwpSampleRemoveByVid(vid);
  });

  $(document).on('click', '.jsc-cart-sample-dropdown-clear', function(e) {
    e.stopPropagation();
    var $clearBtn = $(this);
    var keylist = $clearBtn.attr('data-gwp-keylist') ||
      $('.__remove-allgwp:last').attr('data-gwpkeylist') ||
      $('.__remove-allgwp:last').attr('data-gwpKeylist');

    if (!keylist) return;
    removeAllGwpSample(keylist);
  });

  $(document).on('click', '.jsc-cart-sample-dropdown__tab-chip-remove', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var vid = $(this).attr('data-vid');
    if (!vid) return;

    setGwpSampleManualOverride();
    window.__jscGwpSampleDropdownWasOpen = $('.jsc-cart-sample-dropdown').hasClass('is-open');
    showCartSpinner();
    gwpSampleRemoveByVid(vid);
  });
}
// end: gwp sample dropdown layout